// src/components/Home.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import Footer from '../layout/Footer';
import Header from '../layout/Header';
import LoanEligibilityCalculator from './LoanEligibilityCalculator';
import Timeline from '../common/timeline';
import HeroSlider from '../common/homeslider';
import { toast } from 'react-toastify';
import LoanToastContent from '../common/toaster/loantoastcontent';
import StepsFlow from '../common/stepsflow';

const Home = () => {
  const navigate = useNavigate(); // Add this hook

  const [currentLanguage, setCurrentLanguage] = useState('english');
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [isSecondEmailOpen, setIsSecondEmailOpen] = useState(false);
  const [isSecondMobileOpen, setIsSecondMobileOpen] = useState(false);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [isDSAFormOpen, setIsDSAFormOpen] = useState(false);

  const [openFaqs, setOpenFaqs] = useState({});

  const [selfiePreviewUrl, setSelfiePreviewUrl] = useState('');

  const [officePreviewUrl, setOfficePreviewUrl] = useState('');


  // Add these state variables near other useState declarations
  const [showDsaPopup, setShowDsaPopup] = useState(false);
  const [dsaPopupMessage, setDsaPopupMessage] = useState('');
  const [dsaPopupType, setDsaPopupType] = useState(''); // 'success' or 'error'

  // Add these state variables near other useState declarations
  const [dsaStep, setDsaStep] = useState(1); // 1: Personal, 2: Professional, 3: Documents
  const [gender, setGender] = useState('');

  const [otherDocuments, setOtherDocuments] = useState([{ text: '', file: null, name: '', size: 0, type: '' }]);
  // Array for multiple documents
  const [aadhaarFront, setAadhaarFront] = useState(null);
  const [aadhaarBack, setAadhaarBack] = useState(null);
  const [panCardPhoto, setPanCardPhoto] = useState(null);
  const [cancelCheque, setCancelCheque] = useState(null);
  const [officePhoto, setOfficePhoto] = useState(null);
  const [selfiePhoto, setSelfiePhoto] = useState(null);

  // ADD THIS STATE for animated counters
  const [statCounters, setStatCounters] = useState({
    yearsExp: 0,
    partners: 0,
    freelancers: 0,
    customers: 0
  });


  // Add these state variables near other useState declarations in your Home component
  const [dsaForm, setDsaForm] = useState({
    fullname: '',
    pan: '',
    dob: '',
    email: '',
    mobile: '',
    gender: '',
    aadhaar_number: '',
    address: '',
    pincode: '',
    city: '',
    state: '',
    area: '',
    experience: '',
    profession: '',
    // Nominee fields removed as per request
  });

  const [isLoadingLocation, setIsLoadingLocation] = useState(false);


  // ADD THESE STATES for contact form (add this after statCounters)
  const [contactForm, setContactForm] = useState({
    fullname: '',
    pan_number: '',
    email: '',
    secondary_email: '',
    mobile: '',
    secondary_mobile: '',
    main_product: '',
    sub_product: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);


  // ADD THESE STATE VARIABLES near other useState declarations
  const [dsaSubmitMessage, setDsaSubmitMessage] = useState('');
  const [dsaSubmitStatus, setDsaSubmitStatus] = useState('');


  // To this:
  const [submitMessage, setSubmitMessage] = useState(() => {
    return localStorage.getItem('contactFormMessage') || '';
  });
  const [submitStatus, setSubmitStatus] = useState(() => {
    return localStorage.getItem('contactFormStatus') || '';
  });









  useEffect(() => {
    // Mobile dropdown toggle functionality
    const mobileDropdowns = document.querySelectorAll('.mobile-dropdown > a');
    const mobileSubmenuTriggers = document.querySelectorAll('.mobile-submenu-trigger');

    mobileDropdowns.forEach(dropdown => {
      dropdown.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          const parent = dropdown.parentElement;
          parent.classList.toggle('active');
        }
      });
    });

    mobileSubmenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          e.stopPropagation();
          const parent = trigger.parentElement;
          parent.classList.toggle('active');
        }
      });
    });

    return () => {
      mobileDropdowns.forEach(dropdown => {
        dropdown.removeEventListener('click', () => { });
      });
      mobileSubmenuTriggers.forEach(trigger => {
        trigger.removeEventListener('click', () => { });
      });
    };
  }, []);

  // Add this useEffect in your component
  useEffect(() => {
    // Mobile Services dropdown toggle
    const servicesMobileTrigger = document.querySelector('.mobile-dropdown > a');
    const allLoanMobileTrigger = document.querySelector('.mobile-submenu-trigger');

    if (servicesMobileTrigger) {
      servicesMobileTrigger.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          const parent = e.target.closest('.mobile-dropdown');
          parent.classList.toggle('active');
        }
      });
    }

    if (allLoanMobileTrigger) {
      allLoanMobileTrigger.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          e.stopPropagation();
          const parent = e.target.closest('.mobile-submenu');
          parent.classList.toggle('active');
        }
      });
    }

    return () => {
      if (servicesMobileTrigger) {
        servicesMobileTrigger.removeEventListener('click', () => { });
      }
      if (allLoanMobileTrigger) {
        allLoanMobileTrigger.removeEventListener('click', () => { });
      }
    };
  }, []);

  // Add this useEffect to handle hover delays
  useEffect(() => {
    let hoverTimer;
    const servicesDropdown = document.querySelector('.services-dropdown');
    const dropdownContent = document.querySelector('.services-dropdown-content');

    if (servicesDropdown && dropdownContent) {
      servicesDropdown.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimer);
        dropdownContent.style.display = 'block';
      });

      servicesDropdown.addEventListener('mouseleave', () => {
        hoverTimer = setTimeout(() => {
          dropdownContent.style.display = 'none';
        }, 300); // 300ms delay before closing
      });

      dropdownContent.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimer);
      });

      dropdownContent.addEventListener('mouseleave', () => {
        hoverTimer = setTimeout(() => {
          dropdownContent.style.display = 'none';
        }, 300);
      });
    }

    return () => {
      clearTimeout(hoverTimer);
    };
  }, []);












  // Function to save current step data
  const saveCurrentStep = () => {
    // You can save to localStorage or state here
    console.log('Saving step', dsaStep, 'data:', dsaForm);
  };

  // Updated goToNextStep function with popup error handling
  const goToNextStep = async () => {
    if (validateCurrentStep()) {
      saveCurrentStep();

      try {
        // Call step API based on current step
        if (dsaStep === 1) {
          await submitStep1();
        } else if (dsaStep === 2) {
          await submitStep2();
        }

        // Move to next step only if API call is successful
        setDsaStep(prev => prev + 1);
      } catch (error) {
        // Show error in popup instead of console
        const errorMessage = error.message || 'An error occurred. Please try again.';
        setDsaPopupMessage(errorMessage);
        setDsaPopupType('error');
        setShowDsaPopup(true);

        // Auto-hide after 5 seconds
        setTimeout(() => {
          setShowDsaPopup(false);
        }, 5000);
      }
    }
  };

  // Add this function for Step 1 API submission
  // Add this function for Step 1 API submission
  const submitStep1 = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://kfs09.in/api';

      const formData = new FormData();
      formData.append('full_name', dsaForm.fullname);
      formData.append('pan_number', dsaForm.pan.toUpperCase());
      formData.append('date_of_birth', dsaForm.dob);
      formData.append('email', dsaForm.email);
      formData.append('mobile_number', dsaForm.mobile);
      formData.append('gender', dsaForm.gender.toLowerCase());
      formData.append('aadhar_number', dsaForm.aadhaar_number);
      formData.append('address', dsaForm.address);
      formData.append('pincode', dsaForm.pincode);
      formData.append('city', dsaForm.city);
      formData.append('area_locality', dsaForm.area);
      formData.append('state', dsaForm.state);

      const response = await fetch(`${apiUrl}/v1/partner/step1`, {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        if (result.data && result.data.user_id) {
          localStorage.setItem('dsa_user_id', result.data.user_id);
        }
        console.log('Step 1 submitted successfully:', result);
        return result;
      } else {
        // Extract detailed error messages from backend
        let errorMessage = 'Step 1 submission failed';

        if (result.errors) {
          // Use the helper function to format errors
          errorMessage = formatBackendErrors(result.errors);
        } else if (result.message) {
          errorMessage = result.message;
        }

        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('Error submitting Step 1:', error);
      throw error; // Re-throw to be caught by goToNextStep
    }
  };

  // Add this function for Step 2 API submission
  // Add this function for Step 2 API submission
  const submitStep2 = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://kfs09.in/api';
      const userId = localStorage.getItem('dsa_user_id');

      if (!userId) {
        throw new Error('User ID not found. Please complete Step 1 first.');
      }

      const formData = new FormData();
      formData.append('user_id', userId);
      formData.append('experience_years', dsaForm.experience);
      formData.append('current_profession', dsaForm.profession);

      if (selfiePhoto) {
        formData.append('selfie_photo', selfiePhoto);
      }
      if (officePhoto) {
        formData.append('office_photo', officePhoto);
      }

      const response = await fetch(`${apiUrl}/v1/partner/step2`, {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        console.log('Step 2 submitted successfully:', result);
        return result;
      } else {
        // Extract detailed error messages from backend
        let errorMessage = 'Step 2 submission failed';

        if (result.errors) {
          // Use the helper function to format errors
          errorMessage = formatBackendErrors(result.errors);
        } else if (result.message) {
          errorMessage = result.message;
        }

        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('Error submitting Step 2:', error);
      throw error; // Re-throw to be caught by goToNextStep
    }
  };

  // Function to go to previous step
  const goToPrevStep = () => {
    setDsaStep(prev => prev - 1);
  };

  // Function to validate current step
  const validateCurrentStep = () => {
    switch (dsaStep) {
      case 1: // Personal Information
        // Remove password from validation
        if (!dsaForm.fullname || !dsaForm.pan || !dsaForm.dob ||
          !dsaForm.email || !dsaForm.mobile || !dsaForm.gender ||
          !dsaForm.aadhaar_number || !dsaForm.address || !dsaForm.pincode) {
          alert('Please fill all required fields in Personal Information');
          return false;
        }

        const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
        if (!panRegex.test(dsaForm.pan)) {
          alert('Please enter a valid PAN number');
          return false;
        }

        if (!/^\d{12}$/.test(dsaForm.aadhaar_number)) {
          alert('Please enter a valid 12-digit Aadhaar number');
          return false;
        }

        return true;

      case 2: // Professional Information
        if (!dsaForm.experience || !dsaForm.profession) {
          alert('Please fill all required fields in Professional Information');
          return false;
        }
        return true;

      case 3: // Documents
        if (!aadhaarFront || !aadhaarBack || !panCardPhoto || !cancelCheque) {
          alert('Please upload all required documents');
          return false;
        }
        return true;

      default:
        return true;
    }
  };


  // Handle gender change
  const handleGenderChange = (value) => {
    setDsaForm(prev => ({ ...prev, gender: value }));
    setGender(value);
  };


  // ===== ADD STEP 3 API FUNCTION HERE =====
  const submitStep3 = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://kfs09.in/api';
      const userId = localStorage.getItem('dsa_user_id');

      if (!userId) {
        throw new Error('User ID not found. Please complete previous steps first.');
      }

      const formData = new FormData();
      formData.append('user_id', userId);
      formData.append('terms_accepted', 'true');

      // Append required documents
      if (aadhaarFront) formData.append('aadhar_card_front', aadhaarFront);
      if (aadhaarBack) formData.append('aadhar_card_back', aadhaarBack);
      if (panCardPhoto) formData.append('pan_card', panCardPhoto);
      if (cancelCheque) formData.append('cancel_cheque', cancelCheque);

      // Append other documents - FIXED
      otherDocuments.forEach((doc, index) => {
        if (doc && doc.file) {
          formData.append(`other_documents[${index}][file]`, doc.file);
          formData.append(`other_documents[${index}][document_type]`, doc.type || 'other');
          formData.append(`other_documents[${index}][document_name]`, doc.name || `Document ${index + 1}`);
        }
      });

      const response = await fetch(`${apiUrl}/v1/partner/step3`, {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        console.log('Step 3 submitted successfully:', result);
        return result;
      } else {
        // Extract detailed error messages from backend
        let errorMessage = 'Step 3 submission failed';

        if (result.errors) {
          // Use the helper function to format errors
          errorMessage = formatBackendErrors(result.errors);
        } else if (result.message) {
          errorMessage = result.message;
        }

        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('Error submitting Step 3:', error);
      throw error; // Re-throw to be caught by handleDsaSubmit
    }
  };




  // Handle other documents
  const handleOtherDocumentChange = (index, value) => {
    const updatedDocs = [...otherDocuments];
    updatedDocs[index] = {
      ...updatedDocs[index],
      text: value,
      name: value || `Document ${index + 1}`,
      type: 'other'
    };
    setOtherDocuments(updatedDocs);
  };

  const addOtherDocumentField = () => {
    setOtherDocuments([...otherDocuments, {
      text: '',
      file: null,
      name: '',
      size: 0,
      type: 'other'
    }]);
  };

  const removeOtherDocumentField = (index) => {
    if (otherDocuments.length > 1) {
      const updatedDocs = otherDocuments.filter((_, i) => i !== index);
      setOtherDocuments(updatedDocs);
    }
  };

  // File upload handlers
  const handleFileUpload = (setter, file, maxSizeMB = 5, type = 'general') => {
    if (!file) return;

    const maxSize = maxSizeMB * 1024 * 1024; // Convert MB to bytes

    if (file.size > maxSize) {
      alert(`File size must be less than ${maxSizeMB}MB`);
      return;
    }

    // Validate file types
    const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    const allowedPdfTypes = ['application/pdf'];
    const allowedTypes = [...allowedImageTypes, ...allowedPdfTypes];

    if (!allowedTypes.includes(file.type)) {
      alert('Please upload only JPG, PNG, or PDF files');
      return;
    }

    setter(file);

    // Create preview for images
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (setter === setSelfiePhoto) {
          setSelfiePreviewUrl(e.target.result);
        } else if (setter === setOfficePhoto) {
          setOfficePreviewUrl(e.target.result);
        } else if (setter === setAadhaarFront) {
          // You can add more preview states for other documents if needed
          console.log('Aadhaar front uploaded');
        }
        // Add more conditions for other document types if needed
      };
      reader.readAsDataURL(file);
    }
  };







  // Update the heroTitleText state and useEffect for typing animation
  const [heroTitleLines, setHeroTitleLines] = useState([]);
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  // Update the typing animation useEffect
  useEffect(() => {
    const titleText = translations[currentLanguage].heroTitle;
    // Split the title into two lines
    const lines = [
      "India's Leading Loan",
      "Financial Services Platform"
    ];

    if (currentLineIndex < lines.length) {
      const currentLine = lines[currentLineIndex];

      if (currentCharIndex < currentLine.length) {
        const typingTimer = setTimeout(() => {
          setHeroTitleLines(prev => {
            const updatedLines = [...prev];
            if (updatedLines.length <= currentLineIndex) {
              updatedLines.push('');
            }
            updatedLines[currentLineIndex] = updatedLines[currentLineIndex] + currentLine[currentCharIndex];
            return updatedLines;
          });
          setCurrentCharIndex(prev => prev + 1);
        }, 50);

        return () => clearTimeout(typingTimer);
      } else {
        // Move to next line
        if (currentLineIndex < lines.length - 1) {
          setCurrentLineIndex(prev => prev + 1);
          setCurrentCharIndex(0);
        } else {
          setIsTypingComplete(true);
        }
      }
    }
  }, [currentCharIndex, currentLineIndex, currentLanguage]);

  // Reset animation when language changes
  useEffect(() => {
    setHeroTitleLines([]);
    setCurrentLineIndex(0);
    setCurrentCharIndex(0);
    setIsTypingComplete(false);
  }, [currentLanguage]);







  const congratulatoryMessages = [
    {
      name: "Raj",
      loanType: "Home",
      status: "approved",
      title: "🎊 Congratulations !!",
      fullName: "Mr. Raj Tailor",
      message: "Your Home loan has been approved.",
      toastType: "success",
    },
    {
      name: "Alpesh",
      loanType: "Car",
      status: "process",
      title: "🔔 Reminder !!",
      fullName: "Mr. Alpesh Navadiya",
      message: "Your car loan request is in the processing stage.",
      toastType: "info",
    },
    {
      name: "Kevin",
      loanType: "Personal",
      status: "rejected",
      title: "🔔 Reminder !!",
      fullName: "Mr. Kevin Navadiya",
      message: "Your personal loan application was rejected.",
      toastType: "error",
    },
    {
      name: "Mohan",
      loanType: "Car",
      status: "disburse",
      title: "🔔 Reminder !!",
      fullName: "Mr. Mohan Chavada ",
      message: "We will disburse your loan soon.",
      toastType: "success",
    },
  ];

  // Update the useEffect for congratulatory popup
  useEffect(() => {
    // const popup = document.querySelector('.congratulations-popup');
    // const popupContent = popup?.querySelector('.popup-content');
    // const closeBtn = document.querySelector('.close-popup');

    // if (!popup || !popupContent) return;

    // let intervalId;
    // let timeoutId;
    // let currentDelay = 5000; // Start with 5 seconds
    // let messageIndex = 0;

    // const showPopup = () => {
    //   // Get current message
    //   const message = congratulatoryMessages[messageIndex];

    //   // Update popup content
    //   popupContent.innerHTML = `
    //   <div style="display: flex; align-items: center;">
    //     <span style="font-size: 24px"></span>
    //     <div>
    //       ${message.html}
    //     </div>
    //   </div>
    // `;

    //   popup.style.display = 'block';
    //   popup.style.animation = 'slideInFromLeft 0.5s ease-out';

    //   // Auto-hide after 3 seconds
    //   setTimeout(() => {
    //     popup.style.animation = 'slideOutToLeft 0.5s ease-out forwards';
    //     setTimeout(() => {
    //       popup.style.display = 'block';
    //     }, 500);
    //   }, 6000);

    //   // Move to next message for next time
    //   messageIndex = (messageIndex + 1) % congratulatoryMessages.length;
    // };

    // // Start showing popups with increasing delay
    // const startPopupSequence = () => {
    //   // Clear any existing intervals/timeouts
    //   if (intervalId) {
    //     clearInterval(intervalId);
    //   }
    //   if (timeoutId) {
    //     clearTimeout(timeoutId);
    //   }

    //   // Show first popup after currentDelay (starts at 5 seconds)
    //   timeoutId = setTimeout(() => {
    //     showPopup();

    //     // Increase delay by 5 seconds for next popup
    //     currentDelay += 5000;

    //     // Schedule next popup with increased delay
    //     setTimeout(startPopupSequence, currentDelay);
    //   }, currentDelay);
    // };

    // // Start the popup sequence
    // startPopupSequence();

    // // Close button functionality
    // if (closeBtn) {
    //   closeBtn.onclick = () => {
    //     popup.style.animation = 'slideOutToLeft 0.5s ease-out forwards';
    //     setTimeout(() => {
    //       popup.style.display = 'none';
    //       // Clear current interval and timeout
    //       if (intervalId) {
    //         clearInterval(intervalId);
    //       }
    //       if (timeoutId) {
    //         clearTimeout(timeoutId);
    //       }
    //       // Restart after current delay
    //       setTimeout(startPopupSequence, currentDelay);
    //     }, 500);
    //   };
    // }

    // // Cleanup
    // return () => {
    //   if (intervalId) {
    //     clearInterval(intervalId);
    //   }
    //   if (timeoutId) {
    //     clearTimeout(timeoutId);
    //   }
    // };


  }, []);


  const toasterFun = () => {
    congratulatoryMessages.forEach((toastData, index) => {
      if (!toastData) return;

      setTimeout(() => {
        const ToastComponent = (
          <LoanToastContent
            title={toastData.title}
            fullName={toastData.fullName}
            message={toastData.message}
            highlight={toastData.highlight}
          />
        );

        toast[toastData.toastType](ToastComponent, {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }, index * 5500); // ⏱ delay between each toast
    });
  }

  useEffect(() => {
    toasterFun();
  }, []);






  // ... rest of your translations object remains the same ...


  useEffect(() => {
    // Function to load and process saved data
    const loadAndProcessData = () => {
      try {
        const savedCounters = localStorage.getItem('kfs09_statCounters');
        const savedLastUpdates = localStorage.getItem('kfs09_statLastUpdates');
        const savedIsFirstIncrement = localStorage.getItem('kfs09_firstIncrementDone');

        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize to start of day

        // Default starting values
        const defaultCounters = {
          yearsExp: 28,
          partners: 250,
          freelancers: 5001,   // Starting point
          customers: 50002     // Starting point
        };

        let countersToUse = defaultCounters;
        let shouldSave = false;
        let isFirstIncrement = savedIsFirstIncrement !== 'true'; // Check if first increment is done

        if (savedCounters) {
          const parsedCounters = JSON.parse(savedCounters);
          const lastUpdate = savedLastUpdates ? new Date(savedLastUpdates) : null;

          if (lastUpdate) {
            lastUpdate.setHours(0, 0, 0, 0);

            // Calculate days passed since last update
            const timeDiff = today.getTime() - lastUpdate.getTime();
            const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

            if (daysDiff > 0) {
              countersToUse = { ...parsedCounters };
              console.log(`Applying ${daysDiff} day(s) of missed increments`);

              for (let i = 0; i < daysDiff; i++) {
                // Check if this is the first increment ever
                const isFirstDayOfIncrement = (i === 0 && isFirstIncrement);

                if (isFirstDayOfIncrement) {
                  // First increment: Freelancers +1, Customers +2
                  countersToUse.freelancers += 1;
                  countersToUse.customers += 2;
                  console.log('Applied FIRST increment: Freelancers +1, Customers +2');
                } else {
                  // Normal daily increment: 1, 2, or 3
                  countersToUse.freelancers += Math.floor(Math.random() * 3) + 1; // 1-3
                  countersToUse.customers += Math.floor(Math.random() * 3) + 1;   // 1-3
                }
              }

              // Mark first increment as done
              if (isFirstIncrement && daysDiff > 0) {
                localStorage.setItem('kfs09_firstIncrementDone', 'true');
                isFirstIncrement = false;
              }

              shouldSave = true;
            } else {
              countersToUse = parsedCounters;
            }
          } else {
            countersToUse = parsedCounters;
          }
        } else {
          // First time user
          shouldSave = true;
        }

        // Save updated data
        if (shouldSave) {
          localStorage.setItem('kfs09_statCounters', JSON.stringify(countersToUse));
          localStorage.setItem('kfs09_statLastUpdates', today.toISOString());
        }

        console.log('Loaded counters for animation:', countersToUse);
        return countersToUse;

      } catch (error) {
        console.error('Error loading saved data:', error);
        return {
          yearsExp: 28,
          partners: 250,
          freelancers: 5001,
          customers: 50002
        };
      }
    };

    // Load and process data first
    const processedCounters = loadAndProcessData();

    // Set the state to ZERO first for animation
    setStatCounters({
      yearsExp: 0,
      partners: 0,
      freelancers: 0,
      customers: 0
    });

    // Animation configuration
    const finalStats = processedCounters;
    const animationConfig = [
      { key: 'yearsExp', final: finalStats.yearsExp, duration: 2000, delay: 0 },
      { key: 'partners', final: finalStats.partners, duration: 2200, delay: 200 },
      { key: 'freelancers', final: finalStats.freelancers, duration: 2400, delay: 400 },
      { key: 'customers', final: finalStats.customers, duration: 2600, delay: 600 }
    ];

    const timeoutIds = [];

    // Function to animate a single counter
    const animateCounter = (statKey, finalValue, duration, delay) => {
      const timeoutId = setTimeout(() => {
        const startTime = performance.now();

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeOutExpo = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
          const currentValue = Math.floor(easeOutExpo * finalValue);

          setStatCounters(prev => ({
            ...prev,
            [statKey]: currentValue
          }));

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            setStatCounters(prev => ({
              ...prev,
              [statKey]: finalValue
            }));
          }
        };

        requestAnimationFrame(animate);
      }, delay);

      timeoutIds.push(timeoutId);
    };

    // Start animations after a small delay
    setTimeout(() => {
      animationConfig.forEach(({ key, final, duration, delay }) => {
        animateCounter(key, final, duration, delay);
      });
    }, 500);

    // ========== DAILY INCREMENT SCHEDULER ==========
    const scheduleDailyIncrement = () => {
      // Calculate time until next day (24 hours from now)
      const twentyFourHours = 24 * 60 * 60 * 1000;

      console.log('⏰ Next daily increment scheduled in 24 hours');

      const dailyTimeout = setTimeout(() => {
        // Check if this is the first increment
        const isFirstIncrementDone = localStorage.getItem('kfs09_firstIncrementDone') === 'true';

        setStatCounters(prev => {
          let freelancerIncrement, customerIncrement;

          if (!isFirstIncrementDone) {
            // FIRST INCREMENT: Freelancers +1, Customers +2
            freelancerIncrement = 1;
            customerIncrement = 2;
            console.log('🎯 FIRST INCREMENT: Freelancers +1, Customers +2');
            localStorage.setItem('kfs09_firstIncrementDone', 'true');
          } else {
            // NORMAL DAILY INCREMENT: 1, 2, or 3
            freelancerIncrement = Math.floor(Math.random() * 3) + 1; // 1-3
            customerIncrement = Math.floor(Math.random() * 3) + 1;   // 1-3
            console.log(`📈 NORMAL DAILY: Freelancers +${freelancerIncrement}, Customers +${customerIncrement}`);
          }

          const updated = {
            ...prev,
            freelancers: prev.freelancers + freelancerIncrement,
            customers: prev.customers + customerIncrement
          };

          console.log('✅ Daily increment applied:', {
            date: new Date().toLocaleDateString('en-IN'),
            type: !isFirstIncrementDone ? 'First' : 'Normal',
            freelancerIncrement,
            customerIncrement,
            newFreelancers: updated.freelancers,
            newCustomers: updated.customers
          });

          // Save to localStorage
          localStorage.setItem('kfs09_statCounters', JSON.stringify(updated));
          localStorage.setItem('kfs09_statLastUpdates', new Date().toISOString());

          // Schedule next increment
          scheduleDailyIncrement();

          return updated;
        });

      }, twentyFourHours);

      timeoutIds.push(dailyTimeout);
    };

    // Start the daily increment schedule
    scheduleDailyIncrement();

    // Cleanup function
    return () => {
      timeoutIds.forEach(id => clearTimeout(id));
    };
  }, []);













  // Add this useEffect for rupee note animation - place it after other useEffect hooks
  useEffect(() => {
    // ========== SAFE DOM UTILITY FUNCTIONS ==========
    const safeQuerySelector = (selector) => {
      if (typeof document === 'undefined') return null;
      try {
        return document.querySelector(selector);
      } catch (error) {
        console.warn('Error querying selector:', error);
        return null;
      }
    };

    const safeAppendChild = (parent, child) => {
      if (!parent || !child) return false;
      if (typeof parent.appendChild !== 'function') return false;

      try {
        parent.appendChild(child);
        return true;
      } catch (error) {
        console.warn('Error appending child:', error);
        return false;
      }
    };

    const safeGetBoundingClientRect = (element) => {
      if (!element || typeof element.getBoundingClientRect !== 'function') {
        return null;
      }

      try {
        return element.getBoundingClientRect();
      } catch (error) {
        console.warn('Error getting bounding rect:', error);
        return null;
      }
    };
    // ========== END SAFE UTILITIES ==========

    // Check if hero section exists before starting animations
    const heroSection = safeQuerySelector('.hero-slide');
    if (!heroSection) {
      console.warn('Hero section not found, skipping rupee animation');
      return;
    }

    const createRupeeNotes = () => {
      // Check if container already exists
      let notesContainer = safeQuerySelector('.rupee-notes-container');
      if (!notesContainer) {
        notesContainer = document.createElement('div');
        notesContainer.className = 'rupee-notes-container';
        safeAppendChild(heroSection, notesContainer);
      }

      const noteCount = 40;

      for (let i = 0; i < noteCount; i++) {
        const note = document.createElement('div');
        note.className = 'rupee-note';

        const is500Note = Math.random() < 0.6;
        const noteType = is500Note ? '500' : '200';

        note.setAttribute('data-note-type', noteType);

        const startX = Math.random() * 100 - 50;
        const endX = Math.random() * 100 - 50;
        const startRotation = Math.random() * 90 - 45;
        const endRotation = startRotation + 180 + Math.random() * 180;
        const duration = 15 + Math.random() * 10;
        let size = is500Note ? 80 + Math.random() * 40 : 60 + Math.random() * 30;
        const opacity = 0.7 + Math.random() * 0.3;
        const delay = Math.random() * 10;

        note.style.setProperty('--start-x', startX);
        note.style.setProperty('--end-x', endX);
        note.style.setProperty('--start-rotation', `${startRotation}deg`);
        note.style.setProperty('--end-rotation', `${endRotation}deg`);
        note.style.setProperty('--note-opacity', opacity);

        note.style.left = `${Math.random() * 100}%`;
        note.style.animationDuration = `${duration}s`;
        note.style.animationDelay = `${delay}s`;
        note.style.width = `${size}px`;
        note.style.height = `${size * 0.48}px`;
        note.style.opacity = opacity;

        // Inner realistic elements
        const securityThread = document.createElement('div');
        securityThread.className = 'security-thread';
        const mahatmaPortrait = document.createElement('div');
        mahatmaPortrait.className = 'mahatma-portrait';
        const ashokaChakra = document.createElement('div');
        ashokaChakra.className = 'ashoka-chakra';
        const watermark = document.createElement('div');
        watermark.className = 'watermark';

        note.appendChild(securityThread);
        note.appendChild(mahatmaPortrait);
        note.appendChild(ashokaChakra);
        note.appendChild(watermark);

        safeAppendChild(notesContainer, note);
      }
    };

    // BIGGER EXPLOSION FUNCTION - Now with 80 pieces!
    const createExplosion = (noteType, centerX, centerY) => {
      const explosionCount = 80; // Increased for BIG explosion 💥
      const notesContainer = safeQuerySelector('.rupee-notes-container');
      if (!notesContainer) return;

      for (let i = 0; i < explosionCount; i++) {
        const piece = document.createElement('div');
        piece.className = 'rupee-note rupee-piece';
        piece.setAttribute('data-note-type', noteType);

        piece.style.left = `${centerX}%`;
        piece.style.top = `${centerY}px`;

        const size = 30 + Math.random() * 50; // Bigger pieces
        piece.style.width = `${size}px`;
        piece.style.height = `${size * 0.48}px`;

        const angle = Math.random() * 360;
        const force = 300 + Math.random() * 400; // Stronger force = bigger spread
        const vx = Math.cos(angle * Math.PI / 180) * force;
        const vy = Math.sin(angle * Math.PI / 180) * force - 200; // Upward boost
        const rotation = Math.random() * 1080 - 540; // Wild spinning

        piece.style.setProperty('--scatter-x', `${vx}px`);
        piece.style.setProperty('--scatter-y', `${vy}px`);
        piece.style.setProperty('--scatter-rot', `${rotation}deg`);
        piece.style.opacity = 0.9;

        // Inner elements for realism
        const securityThread = document.createElement('div');
        securityThread.className = 'security-thread';
        const mahatmaPortrait = document.createElement('div');
        mahatmaPortrait.className = 'mahatma-portrait';
        const ashokaChakra = document.createElement('div');
        ashokaChakra.className = 'ashoka-chakra';
        const watermark = document.createElement('div');
        watermark.className = 'watermark';
        piece.appendChild(securityThread);
        piece.appendChild(mahatmaPortrait);
        piece.appendChild(ashokaChakra);
        piece.appendChild(watermark);

        safeAppendChild(notesContainer, piece);

        // Remove after animation
        setTimeout(() => {
          if (piece && piece.parentNode) {
            piece.remove();
          }
        }, 2500);
      }
    };

    // Updated createExplodingNote function - Now with left/right positions
    const createExplodingNote = (noteType, delay = 0, position = 'center') => {
      setTimeout(() => {
        const notesContainer = safeQuerySelector('.rupee-notes-container');
        if (!notesContainer) return;

        const note = document.createElement('div');
        note.className = 'rupee-note exploding-note';
        note.setAttribute('data-note-type', noteType);

        // Default size as per your last request
        note.style.width = '150px';
        note.style.height = '72px';
        note.style.opacity = '1';
        note.style.zIndex = '10';

        // Inner realistic elements
        const securityThread = document.createElement('div');
        securityThread.className = 'security-thread';
        const mahatmaPortrait = document.createElement('div');
        mahatmaPortrait.className = 'mahatma-portrait';
        const ashokaChakra = document.createElement('div');
        ashokaChakra.className = 'ashoka-chakra';
        const watermark = document.createElement('div');
        watermark.className = 'watermark';
        note.appendChild(securityThread);
        note.appendChild(mahatmaPortrait);
        note.appendChild(ashokaChakra);
        note.appendChild(watermark);

        safeAppendChild(notesContainer, note);

        // Set starting position
        note.style.top = '-200px';

        if (position === 'left') {
          note.style.left = '25%';                    // Left side center
          note.style.transform = 'translateX(-50%)';
        } else if (position === 'right') {
          note.style.left = '75%';                    // Right side center
          note.style.transform = 'translateX(-50%)';
        } else {
          note.style.left = '50%';                    // Center
          note.style.transform = 'translateX(-50%)';
        }

        // Trigger fall animation
        requestAnimationFrame(() => {
          note.style.transition = 'all 3.8s cubic-bezier(0.2, 0.6, 0.4, 1)';

          if (position === 'left' || position === 'right') {
            note.style.top = 'calc(72vh - 80px)';
            note.style.transform = 'translateX(-50%) rotate(240deg)';
          } else {
            note.style.top = 'calc(50vh - 80px)';
            note.style.transform = 'translateX(-50%) rotate(240deg)';
          }
        });

        // Explode when reaches its target position - WITH SAFE CHECKS
        setTimeout(() => {
          // Check if elements still exist
          if (!note || !notesContainer) return;

          try {
            const rect = safeGetBoundingClientRect(note);
            const containerRect = safeGetBoundingClientRect(notesContainer);

            // Make sure both rects are valid
            if (!rect || !containerRect) {
              // Just remove the note if we can't get positions
              if (note && note.parentNode) {
                note.remove();
              }
              return;
            }

            const centerX = ((rect.left + rect.width / 2) - containerRect.left) / containerRect.width * 100;
            const centerY = rect.top - containerRect.top + rect.height / 2;

            createExplosion(noteType, centerX, centerY);

            // Safely remove the note
            if (note && note.parentNode) {
              note.remove();
            }
          } catch (error) {
            console.warn('Error in explosion animation:', error);
            // Just remove the note if there's an error
            if (note && note.parentNode) {
              note.remove();
            }
          }
        }, 3800);
      }, delay);
    };

    // Create container
    const notesContainer = document.createElement('div');
    notesContainer.className = 'rupee-notes-container';
    safeAppendChild(heroSection, notesContainer);

    // BIG EXPLOSION SEQUENCE
    createExplodingNote('200', 1000, 'left');   // 200 note → left side center
    createExplodingNote('500', 2200, 'right');  // 500 note → right side center

    // Regular falling notes start after explosions
    setTimeout(() => {
      createRupeeNotes();
    }, 7000);

    return () => {
      const container = safeQuerySelector('.rupee-notes-container');
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }

      // Also remove any floating notes
      const floatingNotes = document.querySelectorAll('.rupee-note');
      floatingNotes.forEach(note => {
        if (note && note.parentNode) {
          note.parentNode.removeChild(note);
        }
      });
    };
  }, []);










  useEffect(() => {
    // ===== DOM ELEMENTS =====
    const chatbotToggle = document.getElementById('chatbotToggle');
    const chatWindow = document.getElementById('chatWindow');
    const chatBody = document.getElementById('chatBody');
    const chatInput = document.getElementById('chatInput');
    const sendBtn = document.getElementById('sendBtn');
    const closeBtn = document.getElementById('closeBtn');
    const minimizeBtn = document.getElementById('minimizeBtn');
    const quickActions = document.getElementById('quickActions');

    // ===== CHAT STATE =====
    let isOpen = false;
    let userName = '';

    // ===== USER DATA =====
    let userData = {
      cibilScore: 720, // Default score
      monthlyIncome: 75000,
      existingEMI: 15000
    };

    // ===== INITIALIZE =====
    function initChatbot() {
      // Load saved data
      const savedName = localStorage.getItem('loanChatUserName');
      if (savedName) {
        userName = savedName;
      }
    }

    // ===== UI FUNCTIONS =====
    function toggleChat() {
      isOpen = !isOpen;
      chatWindow.style.display = isOpen ? 'flex' : 'none';
      if (isOpen) {
        chatInput.focus();
        chatbotToggle.innerHTML = '<i class="fas fa-times"></i>';
        // Show welcome message only when opening first time
        if (chatBody.children.length === 0) {
          showTypingIndicator(() => {
            addBotMessage(`Hello${userName ? ' ' + userName : ''}! I'm Krishna Loan Assistant. I can help you with: loans, EMI calculations, CIBIL score checks, eligibility checks, and more. How can I assist you today?`);
          }, 1000);
        }
      } else {
        chatbotToggle.innerHTML = '<i class="fas fa-comments"></i><div class="pulse-ring"></div>';
      }
    }

    function addMessage(text, sender, delay = 0) {
      setTimeout(() => {
        const messageDiv = document.createElement('div');
        messageDiv.className = `message ${sender}-message`;
        messageDiv.innerHTML = text;
        chatBody.appendChild(messageDiv);
        chatBody.scrollTop = chatBody.scrollHeight;
      }, delay);
    }

    function addBotMessage(text, delay = 0) {
      addMessage(text, 'bot', delay);
    }

    function addUserMessage(text) {
      addMessage(text, 'user');
    }

    function showTypingIndicator(callback, duration = 1500) {
      const typingDiv = document.createElement('div');
      typingDiv.className = 'typing-indicator';
      typingDiv.id = 'typingIndicator';
      typingDiv.innerHTML = `
            <div class="typing-dot"></div>
            <div class="typing-dot"></div>
            <div class="typing-dot"></div>
        `;
      chatBody.appendChild(typingDiv);
      chatBody.scrollTop = chatBody.scrollHeight;

      setTimeout(() => {
        typingDiv.remove();
        if (callback) callback();
      }, duration);
    }

    // ===== CIBIL SCORE CHECKER =====
    function showCIBILScoreChecker() {
      const cibilHTML = `
            <div class="calculator-container">
                <div class="calculator-title">
                    <i class="fas fa-chart-line"></i>
                    CIBIL Score Checker
                </div>
                <div class="calculator-input">
                    <label>Your CIBIL Score (300-900)</label>
                    <input type="number" id="cibilScore" placeholder="e.g., 750" value="${userData.cibilScore}" min="300" max="900">
                </div>
                <div class="calculator-result">
                    <div>Your CIBIL Score</div>
                    <div class="result-amount" id="cibilResult" style="font-size: 2.5rem; color: ${getCibilColor(userData.cibilScore)};">${userData.cibilScore}</div>
                    <div id="cibilStatus" style="font-weight: 600; color: ${getCibilColor(userData.cibilScore)};">${getCibilStatus(userData.cibilScore)}</div>
                    <div class="result-note">${getCibilDescription(userData.cibilScore)}</div>
                    <div style="margin-top: 15px; font-size: 13px;">
                        <strong>Impact on Loan Approval:</strong><br>
                        ${getLoanImpact(userData.cibilScore)}
                    </div>
                </div>
                <div class="quick-actions" style="margin-top: 15px; display: flex; gap: 10px;">
                    <button class="action-btn" style="flex: 1;" onclick="improveCIBILScoreTips()">
                        <i class="fas fa-rocket"></i> Improve Score
                    </button>
                    <button class="action-btn" style="flex: 1;" onclick="checkEligibilityWithCIBIL()">
                        <i class="fas fa-check-circle"></i> Check Eligibility
                    </button>
                </div>
                <button class="action-btn" style="margin-top: 10px; width: 100%;" onclick="updateCIBILScore()">
                    <i class="fas fa-sync-alt"></i> Update CIBIL Score
                </button>
            </div>
        `;

      addBotMessage(cibilHTML);
    }

    function getCibilColor(score) {
      if (score >= 750) return '#4CAF50';
      if (score >= 650) return '#FF9800';
      return '#f44336';
    }

    function getCibilStatus(score) {
      if (score >= 750) return 'Excellent ✓';
      if (score >= 700) return 'Good ✓';
      if (score >= 650) return 'Fair ⚠️';
      if (score >= 550) return 'Poor ❌';
      return 'Very Poor ❌';
    }

    function getCibilDescription(score) {
      if (score >= 750) return 'You qualify for the best interest rates and highest loan amounts.';
      if (score >= 700) return 'Good score. You can get competitive interest rates.';
      if (score >= 650) return 'Average score. Rates may be higher, consider improving.';
      if (score >= 550) return 'Low score. May face difficulty getting loans.';
      return 'Very low score. Focus on improving before applying.';
    }

    function getLoanImpact(score) {
      if (score >= 750) return '✅ Easy approval with lowest interest rates';
      if (score >= 700) return '✅ High chance of approval with good rates';
      if (score >= 650) return '⚠️ Approval possible but with higher rates';
      if (score >= 550) return '❌ Approval difficult, needs co-applicant';
      return '❌ Very difficult to get approval';
    }

    function updateCIBILScore() {
      const scoreInput = document.getElementById('cibilScore');
      if (!scoreInput) return;

      const newScore = parseInt(scoreInput.value) || 720;
      if (newScore < 300 || newScore > 900) {
        addBotMessage('Please enter a valid CIBIL score between 300 and 900.');
        return;
      }

      userData.cibilScore = newScore;
      localStorage.setItem('userCibilScore', newScore.toString());

      // Update the display
      const cibilResult = document.getElementById('cibilResult');
      const cibilStatus = document.getElementById('cibilStatus');

      if (cibilResult) cibilResult.textContent = newScore;
      if (cibilResult) cibilResult.style.color = getCibilColor(newScore);
      if (cibilStatus) cibilStatus.textContent = getCibilStatus(newScore);
      if (cibilStatus) cibilStatus.style.color = getCibilColor(newScore);

      addBotMessage(`✅ CIBIL Score updated to ${newScore}. ${getCibilDescription(newScore)}`);
    }

    function checkEligibilityWithCIBIL() {
      const eligibilityHTML = `
            <div class="calculator-container">
                <div class="calculator-title">
                    <i class="fas fa-check-circle"></i>
                    Eligibility Checker (with CIBIL Score)
                </div>
                <div class="calculator-input">
                    <label>Monthly Income (₹)</label>
                    <input type="number" id="monthlyIncome" placeholder="e.g., 75000" value="${userData.monthlyIncome}">
                </div>
                <div class="calculator-input">
                    <label>Existing EMIs (₹)</label>
                    <input type="number" id="existingEMI" placeholder="e.g., 15000" value="${userData.existingEMI}">
                </div>
                <div style="background: #f0f9ff; padding: 12px; border-radius: 8px; margin: 10px 0;">
                    <p style="margin: 0; font-size: 14px;">
                        <i class="fas fa-chart-line"></i> <strong>Your CIBIL Score:</strong> 
                        <span style="color: ${getCibilColor(userData.cibilScore)}; font-weight: bold;">${userData.cibilScore}</span>
                        (${getCibilStatus(userData.cibilScore)})
                    </p>
                </div>
                <div class="calculator-result">
                    <div>Eligibility Status</div>
                    <div class="result-amount" id="eligibilityStatus" style="color: #4CAF50;">Calculating...</div>
                    <div>Approx. Loan Amount: <span id="eligibleAmount">Calculating...</span></div>
                    <div>Interest Rate Range: <span id="interestRateRange">Calculating...</span></div>
                    <div class="result-note">* Based on your CIBIL score and income</div>
                </div>
                <button class="action-btn" style="margin-top: 15px; width: 100%;" onclick="calculateEligibilityWithCIBIL()">
                    <i class="fas fa-calculator"></i> Check Eligibility
                </button>
            </div>
        `;

      addBotMessage(eligibilityHTML);
      setTimeout(calculateEligibilityWithCIBIL, 100);
    }

    function calculateEligibilityWithCIBIL() {
      const income = parseFloat(document.getElementById('monthlyIncome')?.value) || 75000;
      const existingEMI = parseFloat(document.getElementById('existingEMI')?.value) || 15000;
      const cibilScore = userData.cibilScore;

      // Update user data
      userData.monthlyIncome = income;
      userData.existingEMI = existingEMI;

      const netIncome = income - existingEMI;
      let eligibleAmount = netIncome * 0.6 * 60; // 60% of net income for 5 years

      // Adjust based on CIBIL score
      let scoreMultiplier = 1.0;
      let interestRateRange = '';
      let status = '';
      let statusColor = '#4CAF50';

      if (cibilScore >= 800) {
        scoreMultiplier = 1.5;
        interestRateRange = 'Lowest rates (8.5% - 10.5%)';
        status = 'Highly Eligible';
        statusColor = '#4CAF50';
      } else if (cibilScore >= 750) {
        scoreMultiplier = 1.3;
        interestRateRange = 'Competitive rates (9.5% - 12%)';
        status = 'Eligible';
        statusColor = '#4CAF50';
      } else if (cibilScore >= 700) {
        scoreMultiplier = 1.0;
        interestRateRange = 'Standard rates (11% - 14%)';
        status = 'Eligible with conditions';
        statusColor = '#FF9800';
      } else if (cibilScore >= 650) {
        scoreMultiplier = 0.7;
        interestRateRange = 'Higher rates (13% - 16%)';
        status = 'Limited Eligibility';
        statusColor = '#FF9800';
      } else if (cibilScore >= 550) {
        scoreMultiplier = 0.4;
        interestRateRange = 'High rates (15% - 18%)';
        status = 'Low Eligibility';
        statusColor = '#f44336';
      } else {
        scoreMultiplier = 0.2;
        interestRateRange = 'Very high rates (18%+) or not eligible';
        status = 'Not Eligible';
        statusColor = '#f44336';
      }

      eligibleAmount = eligibleAmount * scoreMultiplier;

      // Additional income check
      if (netIncome < 20000) {
        status = 'Not Eligible (Income too low)';
        statusColor = '#f44336';
        eligibleAmount = 0;
      }

      const eligibleAmountFormatted = `₹${eligibleAmount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

      document.getElementById('eligibilityStatus').textContent = status;
      document.getElementById('eligibilityStatus').style.color = statusColor;
      document.getElementById('eligibleAmount').textContent = eligibleAmountFormatted;
      document.getElementById('interestRateRange').textContent = interestRateRange;
    }

    // ===== LOAN CALCULATOR =====
    function showEMICalculator() {
      const calculatorHTML = `
            <div class="calculator-container">
                <div class="calculator-title">
                    <i class="fas fa-calculator"></i>
                    EMI Calculator
                </div>
                <div style="background: #f0f9ff; padding: 10px; border-radius: 8px; margin: 10px 0;">
                    <p style="margin: 0; font-size: 14px;">
                        <i class="fas fa-chart-line"></i> <strong>Your CIBIL Score:</strong> 
                        ${userData.cibilScore} (${getCibilStatus(userData.cibilScore)})
                    </p>
                </div>
                <div class="calculator-input">
                    <label>Loan Amount (₹)</label>
                    <input type="number" id="loanAmount" placeholder="e.g., 500000" value="500000">
                </div>
                <div class="calculator-input">
                    <label>Interest Rate (% per annum)</label>
                    <input type="number" id="interestRate" placeholder="e.g., 8.5" value="${getInterestRateBasedOnCIBIL()}" step="0.1">
                </div>
                <div class="calculator-input">
                    <label>Loan Tenure (Years)</label>
                    <input type="number" id="loanTenure" placeholder="e.g., 5" value="5">
                </div>
                <div class="calculator-result">
                    <div>Monthly EMI</div>
                    <div class="result-amount" id="emiResult">₹10,280</div>
                    <div>Total Interest: <span id="totalInterest">₹116,800</span></div>
                    <div>Total Amount: <span id="totalAmount">₹616,800</span></div>
                    <div class="result-note">* Rates based on your CIBIL score. Actual EMI may vary.</div>
                </div>
                <button class="action-btn" style="margin-top: 15px; width: 100%;" onclick="calculateEMI()">
                    <i class="fas fa-sync-alt"></i> Calculate EMI
                </button>
            </div>
        `;

      addBotMessage(calculatorHTML);
      setTimeout(calculateEMI, 100);
    }

    function getInterestRateBasedOnCIBIL() {
      if (userData.cibilScore >= 750) return 8.5;
      if (userData.cibilScore >= 700) return 10.5;
      if (userData.cibilScore >= 650) return 12.5;
      return 15.0;
    }

    function calculateEMI() {
      const amountInput = document.getElementById('loanAmount');
      const rateInput = document.getElementById('interestRate');
      const tenureInput = document.getElementById('loanTenure');
      const emiResult = document.getElementById('emiResult');
      const totalInterest = document.getElementById('totalInterest');
      const totalAmountEl = document.getElementById('totalAmount');

      if (!amountInput || !emiResult) return;

      const amount = parseFloat(amountInput.value) || 500000;
      const rate = parseFloat(rateInput.value) || 8.5;
      const tenure = parseFloat(tenureInput.value) || 5;

      const monthlyRate = rate / 12 / 100;
      const months = tenure * 12;

      const emi = amount * monthlyRate * Math.pow(1 + monthlyRate, months) /
        (Math.pow(1 + monthlyRate, months) - 1);

      const totalAmt = emi * months;
      const totalInt = totalAmt - amount;

      emiResult.textContent = `₹${emi.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
      totalInterest.textContent = `₹${totalInt.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
      totalAmountEl.textContent = `₹${totalAmt.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    }


    // ===== LOAN DETAILS FUNCTION (MOVE THIS BEFORE showLoanProducts) =====
    function showLoanDetails(type) {
      const loanDetails = {
        personal: {
          name: 'Personal Loan',
          rate: '10.5% - 16% p.a.',
          amount: '₹50,000 to ₹25 Lakhs',
          tenure: '1 to 5 years',
          features: [
            'Quick disbursal within 24 hours',
            'No collateral required',
            'Flexible repayment options',
            'Minimal documentation'
          ],
          eligibility: [
            'Minimum age: 21 years',
            'Minimum income: ₹25,000 per month',
            'Credit score: 650+',
            'Employment: Salaried or self-employed'
          ]
        },
        home: {
          name: 'Home Loan',
          rate: '8.4% - 9.5% p.a.',
          amount: 'Up to ₹5 Crores',
          tenure: 'Up to 30 years',
          features: [
            'Competitive interest rates',
            'Balance transfer facility',
            'Top-up loans available',
            'Prepayment options'
          ],
          eligibility: [
            'Indian resident',
            'Age: 23 to 62 years',
            'Stable income source',
            'Property documents'
          ]
        },
        car: {
          name: 'Car Loan',
          rate: '8.7% - 12% p.a.',
          amount: 'Up to ₹50 Lakhs',
          tenure: '1 to 7 years',
          features: [
            '100% on-road funding',
            'Quick processing',
            'Flexible repayment',
            'Insurance bundled options'
          ],
          eligibility: [
            'Age: 21 to 65 years',
            'Stable income',
            'Valid driving license',
            'Car quotation'
          ]
        },
        business: {
          name: 'Business Loan',
          rate: '12% - 18% p.a.',
          amount: '₹1 Lakh to ₹2 Crore',
          tenure: '1 to 5 years',
          features: [
            'Collateral-free options',
            'Quick disbursal',
            'Flexible tenure',
            'Working capital support'
          ],
          eligibility: [
            'Business vintage: 3+ years',
            'Profitability',
            'ITR for 2 years',
            'Business proof'
          ]
        },
        education: {
          name: 'Education Loan',
          rate: '8.5% - 11% p.a.',
          amount: 'Up to ₹1.5 Crore',
          tenure: 'Up to 15 years',
          features: [
            'Moratorium period',
            'Covers tuition + living',
            'Tax benefits under 80E',
            'No collateral for smaller amounts'
          ],
          eligibility: [
            'Indian student',
            'Admission proof',
            'Co-applicant required',
            'Course recognition'
          ]
        },
        gold: {
          name: 'Gold Loan',
          rate: '7.5% - 14% p.a.',
          amount: 'Up to 75% of gold value',
          tenure: '3 months to 3 years',
          features: [
            'Instant disbursal',
            'Gold security',
            'Flexible repayment',
            'Minimal documentation'
          ],
          eligibility: [
            'Age: 18+ years',
            'Gold purity 18K+',
            'Ownership proof',
            'Identity proof'
          ]
        }
      };

      const loan = loanDetails[type] || loanDetails.personal;

      const detailsHTML = `
        <div class="calculator-container">
            <div class="calculator-title">
                <i class="fas fa-info-circle"></i>
                ${loan.name} Details
            </div>
            <p><strong>Interest Rate:</strong> ${loan.rate}</p>
            <p><strong>Loan Amount:</strong> ${loan.amount}</p>
            <p><strong>Tenure:</strong> ${loan.tenure}</p>
            
            <div style="background: #f0f9ff; padding: 10px; border-radius: 8px; margin: 10px 0;">
                <p style="margin: 0; font-size: 14px;">
                    <i class="fas fa-chart-line"></i> <strong>Your CIBIL Score Impact:</strong> 
                    ${userData.cibilScore >= 750 ? '✅ Eligible for lowest rates' :
          userData.cibilScore >= 650 ? '⚠️ May qualify with standard rates' :
            '❌ Consider improving score first'}
                </p>
            </div>
            
            <p><strong>Key Features:</strong></p>
            <ul style="font-size: 13px; color: #475569; margin: 10px 0 10px 20px;">
                ${loan.features.map(f => `<li>${f}</li>`).join('')}
            </ul>
            
            <p><strong>Eligibility:</strong></p>
            <ul style="font-size: 13px; color: #475569; margin: 10px 0 20px 20px;">
                ${loan.eligibility.map(e => `<li>${e}</li>`).join('')}
            </ul>
            
            <button class="action-btn" style="width: 100%;" onclick="startApplication('${type}')">
                <i class="fas fa-file-signature"></i> Apply for ${loan.name}
            </button>
        </div>
    `;

      addBotMessage(detailsHTML);
    }

    // ADD THIS LINE to expose to global scope (will be added later with other window assignments)
    // window.showLoanDetails = showLoanDetails;


    // ===== LOAN PRODUCTS =====
    function showLoanProducts() {
      const loansHTML = `
        <div class="loan-cards">
            <div class="loan-card" onclick="showLoanDetails('personal')">
                <div class="loan-icon">
                    <i class="fas fa-user-tie"></i>
                </div>
                <div class="loan-name">Personal Loan</div>
                <div class="loan-rate">${userData.cibilScore >= 750 ? '10.5%' : '12%'} - 16% p.a.</div>
            </div>
            <div class="loan-card" onclick="showLoanDetails('home')">
                <div class="loan-icon">
                    <i class="fas fa-home"></i>
                </div>
                <div class="loan-name">Home Loan</div>
                <div class="loan-rate">${userData.cibilScore >= 750 ? '8.4%' : '9.2%'} - 9.5% p.a.</div>
            </div>
            <div class="loan-card" onclick="showLoanDetails('car')">
                <div class="loan-icon">
                    <i class="fas fa-car"></i>
                </div>
                <div class="loan-name">Car Loan</div>
                <div class="loan-rate">${userData.cibilScore >= 750 ? '8.7%' : '10%'} - 12% p.a.</div>
            </div>
            <div class="loan-card" onclick="showLoanDetails('business')">
                <div class="loan-icon">
                    <i class="fas fa-briefcase"></i>
                </div>
                <div class="loan-name">Business Loan</div>
                <div class="loan-rate">12% - 18% p.a.</div>
            </div>
            <div class="loan-card" onclick="showLoanDetails('education')">
                <div class="loan-icon">
                    <i class="fas fa-graduation-cap"></i>
                </div>
                <div class="loan-name">Education Loan</div>
                <div class="loan-rate">8.5% - 11% p.a.</div>
            </div>
            <div class="loan-card" onclick="showLoanDetails('gold')">
                <div class="loan-icon">
                    <i class="fas fa-gem"></i>
                </div>
                <div class="loan-name">Gold Loan</div>
                <div class="loan-rate">7.5% - 14% p.a.</div>
            </div>
        </div>
        <p style="font-size: 12px; color: #64748b; margin-top: 10px;">
            <i class="fas fa-info-circle"></i> Rates shown are based on your CIBIL score (${userData.cibilScore})
        </p>
    `;

      addBotMessage(`<strong>🏦 Our Loan Products</strong><br>Choose from our wide range of loan products. Rates personalized for your CIBIL score:`, 0);
      addBotMessage(loansHTML, 100);
    }

    // ===== IMPROVE CIBIL SCORE TIPS =====
    function improveCIBILScoreTips() {
      const tipsHTML = `
            <div class="calculator-container">
                <div class="calculator-title">
                    <i class="fas fa-rocket"></i>
                    Boost Your CIBIL Score
                </div>
                
                <div class="tips-container">
                    <div class="tips-title">
                        <i class="fas fa-bolt"></i> Quick Improvements (30-60 days)
                    </div>
                    <div class="tip-item">
                        <i class="fas fa-check-circle"></i>
                        <span><strong>Pay credit card bills before due date</strong> - Most impactful (35% weight)</span>
                    </div>
                    <div class="tip-item">
                        <i class="fas fa-check-circle"></i>
                        <span><strong>Reduce credit utilization below 30%</strong> of limit (30% weight)</span>
                    </div>
                    <div class="tip-item">
                        <i class="fas fa-check-circle"></i>
                        <span><strong>Don't close old credit cards</strong> - Longer history helps (15% weight)</span>
                    </div>
                </div>
                
                <div class="tips-container" style="background: #fff8e1; border-left-color: #FF9800; margin-top: 15px;">
                    <div class="tips-title">
                        <i class="fas fa-chart-line"></i> Long-term Strategies
                    </div>
                    <div class="tip-item">
                        <i class="fas fa-calendar-check"></i>
                        <span><strong>Maintain healthy credit mix</strong> - Secured + unsecured loans (10% weight)</span>
                    </div>
                    <div class="tip-item">
                        <i class="fas fa-search"></i>
                        <span><strong>Check CIBIL report annually</strong> for errors and disputes</span>
                    </div>
                    <div class="tip-item">
                        <i class="fas fa-ban"></i>
                        <span><strong>Avoid multiple loan applications</strong> in short period (10% weight)</span>
                    </div>
                </div>
                
                <div style="background: #e8f5e9; padding: 12px; border-radius: 8px; margin-top: 15px;">
                    <p style="margin: 0; font-size: 14px;">
                        <i class="fas fa-chart-line"></i> <strong>Your Current Score:</strong> 
                        <span style="color: ${getCibilColor(userData.cibilScore)}; font-weight: bold;">${userData.cibilScore}</span>
                    </p>
                    <p style="margin: 5px 0 0 0; font-size: 13px;">
                        Follow these tips to reach <span style="color: #4CAF50; font-weight: bold;">750+</span> for best loan rates!
                    </p>
                </div>
                
                <button class="action-btn" style="width: 100%; margin-top: 15px;" onclick="showCIBILScoreChecker()">
                    <i class="fas fa-redo"></i> Re-check My CIBIL Score
                </button>
            </div>
        `;

      addBotMessage(tipsHTML);
    }

    // ===== APPLICATION PROCESS =====
    function startApplication(loanType) {
      const applicationHTML = `
            <div class="calculator-container">
                <div class="calculator-title">
                    <i class="fas fa-file-signature"></i>
                    Start Application
                </div>
                
                <p>To proceed with your ${loanType} loan application:</p>
                
                <div style="background: #f0f9ff; padding: 10px; border-radius: 8px; margin: 10px 0;">
                    <p style="font-size: 13px;"><i class="fas fa-chart-line" style="color: #1e3c72;"></i> 
                    <strong>Your CIBIL Score:</strong> ${userData.cibilScore} 
                    ${userData.cibilScore >= 750 ? '✅ (Good for best rates)' :
          userData.cibilScore >= 650 ? '⚠️ (Average - may affect rates)' :
            '❌ (Needs improvement)'}
                    </p>
                </div>
                
                <div class="quick-actions">
                    <button class="action-btn" onclick="showDocuments()">
                        <i class="fas fa-list"></i> Required Docs
                    </button>
                    <button class="action-btn" onclick="showCIBILScoreChecker()">
                        <i class="fas fa-chart-line"></i> Improve CIBIL Score
                    </button>
                </div>
                
                <div class="calculator-input" style="margin-top: 20px;">
                    <label>Your Mobile Number</label>
                    <input type="tel" id="contactNumber" placeholder="98XXXXXX20" style="width: 100%;">
                </div>
                
                <button class="action-btn" style="width: 100%; margin-top: 15px; background: #4CAF50; color: white;" 
                        onclick="submitContactRequest('${loanType}')">
                    <i class="fas fa-phone-alt"></i> Request Call Back
                </button>
            </div>
        `;

      addBotMessage(applicationHTML);
    }

    function submitContactRequest(loanType) {
      const phone = document.getElementById('contactNumber').value;
      if (phone && phone.length === 10) {
        addUserMessage(`Please call me for ${loanType} loan: ${phone}`);
        showTypingIndicator(() => {
          addBotMessage(`✅ Thank you! Our loan specialist will call you on ${phone} within 30 minutes.`);
          addBotMessage(`Based on your CIBIL Score (${userData.cibilScore}), our expert will suggest the best loan options for you.`);
        }, 1500);
      } else {
        addBotMessage('Please enter a valid 10-digit mobile number.');
      }
    }

    // ===== DOCUMENTS LIST =====
    function showDocuments() {
      const documentsHTML = `
            <div class="calculator-container">
                <div class="calculator-title">
                    <i class="fas fa-file-alt"></i>
                    Required Documents
                </div>
                
                <div style="background: #f0f9ff; padding: 10px; border-radius: 8px; margin: 10px 0;">
                    <p style="font-size: 13px; margin: 0;">
                        <i class="fas fa-chart-line"></i> <strong>CIBIL Score Tip:</strong> 
                        A good CIBIL score (750+) can sometimes reduce documentation requirements.
                    </p>
                </div>
                
                <p><strong>Common Documents for All Loans:</strong></p>
                <ul style="font-size: 13px; color: #475569; margin: 10px 0 20px 20px;">
                    <li>Aadhaar Card</li>
                    <li>PAN Card</li>
                    <li>Passport size photographs (2)</li>
                    <li>Address proof (Electricity bill/Rent agreement)</li>
                </ul>
                
                <p><strong>Income Proof:</strong></p>
                <ul style="font-size: 13px; color: #475569; margin: 10px 0 20px 20px;">
                    <li>Salaried: Last 3 months salary slips + Form 16</li>
                    <li>Self-employed: ITR for last 2 years + P&L statement</li>
                    <li>Last 6 months bank statements</li>
                </ul>
                
                <p><strong>CIBIL Score Report (Recommended):</strong></p>
                <ul style="font-size: 13px; color: #475569; margin: 10px 0 20px 20px;">
                    <li>Latest CIBIL score report</li>
                    <li>Can be obtained from official CIBIL website</li>
                    <li>Helps in faster approval and better rates</li>
                </ul>
                
                <button class="action-btn" style="width: 100%;" onclick="showUploadOption()">
                    <i class="fas fa-cloud-upload-alt"></i> Upload Documents Securely
                </button>
            </div>
        `;

      addBotMessage(documentsHTML);
    }

    // ===== CONTACT FORM =====
    function showContactForm() {
      const contactHTML = `
            <div class="calculator-container">
                <div class="calculator-title">
                    <i class="fas fa-headset"></i>
                    Contact Support
                </div>
                
                <p>Reach out to our support team:</p>
                
                <div style="background: #f8fafc; padding: 15px; border-radius: 10px; margin: 15px 0;">
                    <p><i class="fas fa-phone" style="color: #4CAF50;"></i> <strong>24x7 Helpline:</strong> 1800-XXX-XXXX</p>
                    <p><i class="fas fa-envelope" style="color: #1e3c72;"></i> <strong>Email:</strong> support@krishnaloan.com</p>
                    <p><i class="fas fa-clock" style="color: #FF9800;"></i> <strong>Working Hours:</strong> 9 AM - 8 PM (Mon-Sat)</p>
                </div>
                
                <p><strong>CIBIL Score Assistance:</strong></p>
                <button class="action-btn" style="width: 100%; margin-bottom: 10px;" onclick="showCIBILScoreChecker()">
                    <i class="fas fa-chart-line"></i> CIBIL Score Help
                </button>
                
                <div class="calculator-input" style="margin-top: 15px;">
                    <label>Your Query</label>
                    <textarea id="supportQuery" placeholder="Describe your issue..." rows="3" style="width: 100%; padding: 12px; border-radius: 10px; border: 1px solid #e2e8f0; resize: vertical;"></textarea>
                </div>
                
                <button class="action-btn" style="width: 100%; margin-top: 15px; background: #1e3c72; color: white;" 
                        onclick="submitSupportQuery()">
                    <i class="fas fa-paper-plane"></i> Send Message
                </button>
            </div>
        `;

      addBotMessage(contactHTML);
    }

    // ===== BOT RESPONSES =====
    function handleUserMessage(message) {
      const msg = message.toLowerCase().trim();

      // Store user message
      addUserMessage(message);

      // Clear input
      chatInput.value = '';

      // Show typing indicator
      showTypingIndicator(() => {
        let response = '';

        // Define response patterns
        if (msg.includes('hello') || msg.includes('hi') || msg.includes('hey')) {
          response = `Hello${userName ? ' ' + userName : ''}! 👋 Welcome back to Krishna Loan. How can I assist you with your financial needs today?`;
        }
        else if (msg.includes('cibil') || msg.includes('credit score') || msg.includes('score')) {
          response = `Let me help you check and improve your CIBIL score.`;
          addBotMessage(response);
          setTimeout(() => showCIBILScoreChecker(), 500);
          return;
        }
        else if (msg.includes('emi') || msg.includes('calculator')) {
          response = `Sure! Let me help you calculate your EMI.`;
          addBotMessage(response);
          setTimeout(() => showEMICalculator(), 500);
          return;
        }
        else if (msg.includes('eligibility') || msg.includes('eligible')) {
          response = `Let's check your loan eligibility with your CIBIL score.`;
          addBotMessage(response);
          setTimeout(() => checkEligibilityWithCIBIL(), 500);
          return;
        }
        else if (msg.includes('loan') || msg.includes('product')) {
          response = `We offer various loan products. Here are our popular options:`;
          addBotMessage(response);
          setTimeout(() => showLoanProducts(), 500);
          return;
        }
        else if (msg.includes('apply') || msg.includes('application')) {
          response = `Great! Let's start your loan application process. Which type of loan are you interested in?`;
          addBotMessage(response);
          setTimeout(() => showLoanProducts(), 500);
          return;
        }
        else if (msg.includes('document') || msg.includes('doc')) {
          response = `Here's the list of documents required for loan applications:`;
          addBotMessage(response);
          setTimeout(() => showDocuments(), 500);
          return;
        }
        else if (msg.includes('contact') || msg.includes('support') || msg.includes('help')) {
          response = `Our support team is here to help you:`;
          addBotMessage(response);
          setTimeout(() => showContactForm(), 500);
          return;
        }
        else if (msg.includes('interest rate') || msg.includes('rate')) {
          response = `Our current interest rates based on your CIBIL score (${userData.cibilScore}):<br>
                           • Personal Loan: ${userData.cibilScore >= 750 ? '10.5%' : '12%'} - 16% p.a.<br>
                           • Home Loan: ${userData.cibilScore >= 750 ? '8.4%' : '9.2%'} - 9.5% p.a.<br>
                           • Car Loan: ${userData.cibilScore >= 750 ? '8.7%' : '10%'} - 12% p.a.<br>
                           <br>Better CIBIL score = Better rates!`;
        }
        else if (msg.includes('improve') || msg.includes('boost') || msg.includes('increase')) {
          response = `Let me show you how to improve your CIBIL score.`;
          addBotMessage(response);
          setTimeout(() => improveCIBILScoreTips(), 500);
          return;
        }
        else if (msg.includes('thank')) {
          response = `You're welcome! 😊 If you have any more questions about loans or need CIBIL score assistance, I'm here to help.`;
        }
        else if (msg.includes('bye') || msg.includes('goodbye')) {
          response = `Thank you for visiting Krishna Loan! Have a great day. Remember, we're here whenever you need financial assistance. 👋`;
        }
        else {
          response = `I understand you're asking about "${message}". I can help you with:<br>
                           • CIBIL score checks and improvement<br>
                           • EMI calculations<br>
                           • Loan eligibility checks<br>
                           • Loan product information<br>
                           • Application process<br>
                           • Document requirements<br>
                           <br>What would you like to know more about?`;
        }

        addBotMessage(response);
      }, 1000);
    }

    // Additional utility functions
    function showBranches() {
      addBotMessage(`<strong>📍 Branch Locations</strong><br>
                      • Mumbai: Nariman Point<br>
                      • Delhi: Connaught Place<br>
                      • Bangalore: MG Road<br>
                      • Chennai: Anna Nagar<br>
                      • Kolkata: Park Street<br><br>
                      Find more branches: <a href="#" style="color: #1e3c72;">https://krishnaloan.com/branches</a>`);
    }

    function showUploadOption() {
      addBotMessage(`<strong>📁 Secure Document Upload</strong><br>
                      For your security, please upload documents through:<br><br>
                      1. Our secure portal: <a href="#" style="color: #1e3c72;">https://krishnaloan.com/upload</a><br>
                      2. Mobile App: Available on Play Store & App Store<br>
                      3. WhatsApp: Send to +91-XXXXXXXXXX<br><br>
                      All documents are encrypted and securely stored.`);
    }

    function submitSupportQuery() {
      const query = document.getElementById('supportQuery')?.value;
      if (query) {
        addUserMessage(`Support query: ${query}`);
        showTypingIndicator(() => {
          addBotMessage(`✅ Your query has been submitted. Our support team will respond within 2 hours. Reference ID: LOAN${Date.now().toString().slice(-6)}`);
        }, 1500);
      }
    }

    // ===== EVENT LISTENERS =====
    chatbotToggle.addEventListener('click', toggleChat);

    sendBtn.addEventListener('click', () => {
      if (chatInput.value.trim()) {
        handleUserMessage(chatInput.value);
      }
    });

    chatInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && chatInput.value.trim()) {
        handleUserMessage(chatInput.value);
      }
    });

    closeBtn.addEventListener('click', () => {
      chatWindow.style.display = 'none';
      chatbotToggle.innerHTML = '<i class="fas fa-comments"></i><div class="pulse-ring"></div>';
      isOpen = false;
    });

    minimizeBtn.addEventListener('click', () => {
      chatBody.style.display = chatBody.style.display === 'none' ? 'flex' : 'none';
      minimizeBtn.innerHTML = chatBody.style.display === 'none' ?
        '<i class="fas fa-expand"></i>' : '<i class="fas fa-minus"></i>';
    });

    // Quick actions listener
    if (quickActions._chatListener) {
      quickActions.removeEventListener('click', quickActions._chatListener);
    }

    quickActions._chatListener = (e) => {
      const btn = e.target.closest('.action-btn');
      if (!btn) return;

      const action = btn.dataset.action;

      switch (action) {
        case 'cibilscore':
          addUserMessage('Check CIBIL score');
          setTimeout(() => showCIBILScoreChecker(), 500);
          break;
        case 'emi':
          addUserMessage('Show EMI calculator');
          setTimeout(() => showEMICalculator(), 500);
          break;
        case 'eligibility':
          addUserMessage('Check loan eligibility');
          setTimeout(() => checkEligibilityWithCIBIL(), 500);
          break;
        case 'loans':
          addUserMessage('Show loan products');
          setTimeout(() => showLoanProducts(), 500);
          break;
        case 'apply':
          addUserMessage('I want to apply for a loan');
          setTimeout(() => startApplication('personal'), 500);
          break;
        case 'documents':
          addUserMessage('Show required documents');
          setTimeout(() => showDocuments(), 500);
          break;
        case 'contact':
          addUserMessage('Contact support');
          setTimeout(() => showContactForm(), 500);
          break;
        default:
          break;
      }
    };

    quickActions.addEventListener('click', quickActions._chatListener);

    // Initialize chatbot
    initChatbot();

    // Load saved CIBIL score
    const savedCibilScore = localStorage.getItem('userCibilScore');
    if (savedCibilScore) {
      userData.cibilScore = parseInt(savedCibilScore);
    }

    // Expose functions to global scope (at the end of the useEffect, before cleanup)
    window.showCIBILScoreChecker = showCIBILScoreChecker;
    window.updateCIBILScore = updateCIBILScore;
    window.improveCIBILScoreTips = improveCIBILScoreTips;
    window.checkEligibilityWithCIBIL = checkEligibilityWithCIBIL;
    window.calculateEligibilityWithCIBIL = calculateEligibilityWithCIBIL;
    window.calculateEMI = calculateEMI;
    window.showEMICalculator = showEMICalculator;
    window.checkEligibility = checkEligibilityWithCIBIL;
    window.showLoanProducts = showLoanProducts;
    window.showLoanDetails = showLoanDetails;  // ADD THIS LINE
    window.startApplication = startApplication;
    window.submitContactRequest = submitContactRequest;
    window.showDocuments = showDocuments;
    window.showContactForm = showContactForm;
    window.showBranches = showBranches;
    window.showUploadOption = showUploadOption;
    window.submitSupportQuery = submitSupportQuery;

    // Cleanup event listeners on unmount
    return () => {
      chatbotToggle.removeEventListener('click', toggleChat);
      sendBtn.removeEventListener('click', () => { });
      chatInput.removeEventListener('keypress', () => { });
      closeBtn.removeEventListener('click', () => { });
      minimizeBtn.removeEventListener('click', () => { });
      if (quickActions && quickActions._chatListener) {
        quickActions.removeEventListener('click', quickActions._chatListener);
      }
    };
  }, []);



  const translations = {
    english: {
      logo: 'FinLink',
      navHome: 'Home',
      navServices: 'Services',
      navAbout: 'About us',
      navDsa: 'Become Partner',

      navFaq: 'FAQ',
      navContact: 'Contact',
      navCareer: 'Career with us',
      navHelp: 'Help Desk',
      partnerButton: 'Login',
      applyButton: 'Become DSA',

      heroTitleLine1: "India's Leading Loan",
      heroTitleLine2: "Financial Services Platform",
      heroDescription: 'Connect with 100+ banking partners for Home Loans, Personal Loans, Business Loans, Credit Cards, Insurance and more. Get best rates with instant eligibility check and digital document submission.',
      exploreButton: 'Check Eligibility',
      cibilButton: 'Check CIBIL Score',


      statExpText: 'Years Experience',
      statPartnersText: 'Banking Partners',
      statFreelancersText: 'Freelancers',
      statCustomersText: 'Satiesfied Customer',

      productsTitle: 'We Make a Wide Range of Financial Products Affordable',
      productsSubtitle: 'That suits your client needs! Choose from our comprehensive financial solutions',

      product1Title: 'Home Loan',
      product1Desc: 'Your dream home awaits - Explore our range of home loan products with flexible options.',
      product1Feature1: 'Lowest interest rates starting from 8.5%',
      product1Feature2: 'Up to 90% of property value',
      product1Feature3: 'Long tenure up to 30 years',
      product1Button: 'Check Eligibility',

      product2Title: 'Personal Loan',
      product2Desc: 'Achieve your dreams with our versatile personal loan options for all needs.',
      product2Feature1: 'Up to ₹40 Lakhs amount',
      product2Feature2: 'Instant approval in 24 hours',
      product2Feature3: 'No collateral required',
      product2Button: 'Become DSA',

      product3Title: 'Loan Against Property',
      product3Desc: 'Unlock your property value with ready-made loan solutions at attractive rates.',
      product3Feature1: 'High value loans available',
      product3Feature2: 'Lowest interest rates',
      product3Feature3: 'Flexible repayment options',
      product3Button: 'Get Offers',

      product4Title: 'Business Loan',
      product4Desc: 'Accelerate your business growth with our flexible financing options and quick disbursal.',
      product4Feature1: 'Up to ₹2 Crore',
      product4Feature2: 'Minimal documentation',
      product4Feature3: 'Collateral-free options',
      product4Button: 'Boost Business',

      product5Title: 'Car Loan',
      product5Desc: 'Drive your dream car with our quick and flexible car loans for new and used vehicles.',
      product5Feature1: '100% on-road funding',
      product5Feature2: 'Competitive interest rates',
      product5Feature3: 'Fast processing',
      product5Button: 'Check Offers',

      product6Title: 'Education Loan',
      product6Desc: 'Invest in your child\'s future with our special education loans for domestic studies.',
      product6Feature1: 'Covers tuition + living expenses',
      product6Feature2: 'Moratorium period available',
      product6Feature3: 'Tax benefits under Sec 80E',
      product6Button: 'Apply for Loan',

      insuranceTitle: 'Wide Range of Insurance Products',
      insuranceSubtitle: 'Protect what matters most with our comprehensive insurance solutions',
      insurance1Title: 'Life Insurance',
      insurance1Desc: 'Secure your loved ones future with reliable life insurance plans.',
      insurance1Price: 'Starting at ₹450/month*',
      insurance1Button: 'Get Quote',

      insurance2Title: 'Health Insurance',
      insurance2Desc: 'Ensuring your health is in good hands with best coverage.',
      insurance2Price: 'Starting at ₹450/month*',
      insurance2Button: 'Compare Plans',

      insurance3Title: 'General Insurance',
      insurance3Desc: 'Insurance made easy - Your protection for vehicles and more, our expertise.',
      insurance3Price: 'Starting at ₹450/month*',
      insurance3Button: 'Explore Now',

      processTitle: 'Easy. Convenient. Fast.',
      processSubtitle: 'Simple and quick steps for your loan with 90% success rate',
      step1Title: 'Check Eligibility',
      step1Desc: 'Tell us your need. Our AI matches with best banks based on 90+ criteria.',
      step2Title: 'Compare Offers',
      step2Desc: 'View personalized loan options side by side from 100+ lenders.',
      step3Title: 'Apply Digitally',
      step3Desc: 'Complete application and submit documents directly to selected banks.',
      step4Title: 'Get Disbursal',
      step4Desc: 'Get quick approval and disbursal in hours not weeks.',

      dsaTitle: 'Become DSA Partner',
      dsaSubtitle: 'Join India\'s fastest growing loan distribution network and start earning attractive commissions',
      dsaDescription: 'Loan Agents, Ex-Bankers, Financial Analysts, Insurance Agents, Mutual Fund Agents, Chartered Accountants, Builders or professionals from any field can partner with us.',
      benefit1Title: 'Attractive Commissions',
      benefit1Desc: 'Earn competitive commissions on every successful loan disbursal.',
      benefit2Title: 'Comprehensive Training',
      benefit2Desc: 'Get detailed training on products, processes and sales techniques.',
      benefit3Title: 'Dedicated Support',
      benefit3Desc: '24/7 support team to assist you and your clients throughout the process.',
      dsaButton: 'Register as Partner',

      teamTitle: 'Our Team',
      teamMembers: [
        {
          name: 'Mr Rakesh Panchal',
          position: 'FOUNDER',
          photo: '/avatars/ceo.png'  // Adjust filename if needed, based on your avatars folder
        },
        {
          name: 'Lauren Pybus',
          position: 'VP Growth & Development',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Raelen Thomas',
          position: 'VP Finance Operations',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Mitchell Fawcett',
          position: 'VP Strategy',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Jieu Segal',
          position: 'VP Sales & Marketing',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Darren Maher',
          position: 'Creative Director',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Ben Van Exan',
          position: 'Snr Account Executive',
          photo: '/avatars/amit.png'
        },
        {
          name: 'John Blown',
          position: 'Founding Partner',
          photo: '/avatars/amit.png'
        },
      ],



      faqTitle: 'Frequently Asked Questions',
      faqSubtitle: 'Find Answers To Common Questions About Our Services And Processes',
      faq1Question: 'What is Krishna Finconcept Services and how does it work?',
      faq1Answer: 'Krishna Finconcept Services Is A Comprehensive Financial Services Platform That Connects Customers With 100+ Banking Partners For Loans, Credit Cards And Insurance. We Use AI To Match You With Best Offers, Help With Eligibility Check And Facilitate Digital Document Submission.',
      faq2Question: 'Is my personal and financial information secure?',
      faq2Answer: 'Yes, We Follow Strict Security Protocols And Comply With All Data Protection Regulations. We Never Store Your Bank Login Credentials And Share Information With Lenders Only With Your Explicit Consent For Processing Your Application.',
      faq3Question: 'How can I become a DSA partner?',
      faq3Answer: 'Any Individual Above 25 Years With PAN And Aadhaar Can Become A Partner. Professionals From Finance, Real Estate, Insurance Or Any Field Can Join. We Provide Complete Training, Marketing Support And Timely Commission Payments.',
      faq4Question: 'Do you support all Indian banks?',
      faq4Answer: 'We Partner With 100+ Major Banks And NBFCs Including HDFC, ICICI, SBI, Axis, Kotak, Bajaj Finserv And Many More. While We Don\'t Cover Every Single Bank, We Work With All Major Financial Institutions In India.',





      // New Testimonials
      testimonialTitle: 'What Our Customers Say',
      testimonialSubtitle: 'Hear From Our Satisfied Clients About Their Experience With Krishna Finconcept Services',
      testimonials: [
        {
          name: 'Amit Sharma',
          photo: '/avatars/amit.png',
          rating: 5,
          text: 'Krishna Finconcept Services made getting my home loan so easy! Excellent service and quick approval.'
        },
        {
          name: 'Priya Patel',
          photo: '/avatars/priya.png',
          rating: 5,
          text: 'Great platform with multiple options. Found the best interest rate for my personal loan.'
        },
        {
          name: 'Rahul Verma',
          photo: '/avatars/rahul.png',
          rating: 4,
          text: 'As a DSA partner, Krishna Finconcept Services has boosted my earnings with timely commissions and great support.'
        },
        {
          name: 'Sneha Gupta',
          photo: '/avatars/sneha.png',
          rating: 5,
          text: 'Quick and hassle-free health insurance. Saved a lot compared to direct purchase!'
        },
        {
          name: 'Vikram Singh',
          photo: '/avatars/amit.png',
          rating: 5,
          text: 'User-friendly EMI calculator and seamless business loan application process.'
        }
      ],



      partnersTitle: 'Our Banking Partners',
      partnersSubtitle: 'Trusted by India\'s Leading Financial Institutions',

      footerAbout: 'Krishna Finconcept Services',
      footerDescription: 'India\'s leading financial services platform, connecting customers with 100+ banking partners for loans, credit cards, insurance and investment products.',
      footerProducts: 'Loan Products',
      footerHome: 'Home Loan',
      footerPersonal: 'Personal Loan',
      footerBusiness: 'Business Loan',
      footerLap: 'Loan Against Property',
      footerCar: 'Car Loan',
      footerEducation: 'Education Loan',
      footerServices: 'Other Services',
      footerCredit: 'Credit Cards',
      footerInsurance: 'Insurance',
      footerGold: 'Gold Loan',
      footerBills: 'Bill Payments',
      footerCreditScore: 'Free Credit Score',
      footerPartner: 'Become Partner',
      footerContact: 'Contact Us',
      footerPhone: '9909002220',
      footerEmail: 'krishnafinconcept09@gmail.com',
      footerAddress: 'Available in 4,000+ cities across India',
      footerTiming: 'Mon-Sat: 9AM-9PM | Sun: 10AM-6PM',
      copyrightText: '© 2025 Krishna Finconcept Services Financial Services. All rights reserved.',
      privacyLink: 'Privacy Policy',
      termsLink: 'Terms & Conditions',
      disclaimerLink: 'Disclaimer'
    },
    // FULL hindi translation object (replace the entire hindi: { ... } in your translations)

    // Inside translations = { ... }
    hindi: {
      logo: "फिनलिंक",
      navHome: "होम",
      navServices: "सेवाएं",
      navAbout: 'हमारे बारे में',
      navDsa: "भागीदार बनें",

      navFaq: "सामान्य प्रश्न",
      navContact: "संपर्क करें",
      navCareer: 'करियर हमारे साथ',
      navHelp: 'हेल्प डेस्क',
      partnerButton: "लॉगिन",
      applyButton: "डीएसए बनें",

      heroTitleLine1: "भारत का अग्रणी ऋण",
      heroTitleLine2: "और वित्तीय सेवा प्लेटफॉर्म",
      heroDescription: "100+ बैंकिंग भागीदारों से होम लोन, पर्सनल लोन, बिजनेस लोन, क्रेडिट कार्ड, बीमा और बहुत कुछ के लिए जुड़ें। तत्काल पात्रता जांच और डिजिटल दस्तावेज जमा के साथ सर्वोत्तम दरें प्राप्त करें।",
      exploreButton: "पात्रता जांचें",
      cibilButton: "सीआईबीआईएल स्कोर जांचें",

      statExpText: "वर्षों का अनुभव",
      statPartnersText: "बैंकिंग भागीदार",
      statFreelancersText: "फ्रीलांसर्स",
      statCustomersText: "संतुष्ट ग्राहक",

      productsTitle: "हम वित्तीय उत्पादों की विस्तृत श्रृंखला को सुलभ बनाते हैं",
      productsSubtitle: "जो आपके ग्राहक की जरूरतों के अनुरूप है! हमारे व्यापक वित्तीय समाधानों में से चुनें",

      product1Title: "होम लोन",
      product1Desc: "आपका सपनों का घर इंतजार कर रहा है - लचीले विकल्पों के साथ हमारे होम लोन उत्पादों की श्रृंखला का अन्वेषण करें।",
      product1Feature1: "8.5% से शुरू होने वाली सबसे कम ब्याज दरें",
      product1Feature2: "संपत्ति मूल्य का 90% तक",
      product1Feature3: "30 वर्ष तक की लंबी अवधि",
      product1Button: "पात्रता जांचें",

      product2Title: "पर्सनल लोन",
      product2Desc: "सभी जरूरतों के लिए हमारे बहुमुखी पर्सनल लोन विकल्पों के साथ अपने सपनों को हासिल करें।",
      product2Feature1: "₹40 लाख तक की राशि",
      product2Feature2: "24 घंटे में तत्काल अनुमोदन",
      product2Feature3: "कोई संपार्श्विक आवश्यक नहीं",
      product2Button: "अभी आवेदन करें",

      product3Title: "प्रॉपर्टी के खिलाफ लोन",
      product3Desc: "आकर्षक दरों पर तैयार किए गए लोन समाधानों के साथ अपनी संपत्ति का मूल्य अनलॉक करें।",
      product3Feature1: "उच्च मूल्य के ऋण उपलब्ध",
      product3Feature2: "सबसे कम ब्याज दरें",
      product3Feature3: "लचीले पुनर्भुगतान विकल्प",
      product3Button: "ऑफ़र प्राप्त करें",

      product4Title: "बिजनेस लोन",
      product4Desc: "हमारे लचीले वित्तपोषण विकल्पों और त्वरित वितरण के साथ अपने व्यवसाय की वृद्धि को तेज करें।",
      product4Feature1: "₹2 करोड़ तक",
      product4Feature2: "न्यूनतम दस्तावेजीकरण",
      product4Feature3: "संपार्श्विक-मुक्त विकल्प",
      product4Button: "व्यवसाय को बढ़ावा दें",

      product5Title: "कार लोन",
      product5Desc: "नई और पुरानी गाड़ियों के लिए हमारे त्वरित और लचीले कार लोन के साथ अपनी सपनों की कार चलाएं।",
      product5Feature1: "100% ऑन-रोड फंडिंग",
      product5Feature2: "प्रतिस्पर्धी ब्याज दरें",
      product5Feature3: "तेज प्रसंस्करण",
      product5Button: "ऑफ़र जांचें",

      product6Title: "एजुकेशन लोन",
      product6Desc: "घरेलू और अंतरराष्ट्रीय अध्ययन के लिए हमारे विशेष शिक्षा ऋण के साथ अपने बच्चे के भविष्य में निवेश करें।",
      product6Feature1: "ट्यूशन + रहने के खर्च को कवर करता है",
      product6Feature2: "मोरेटोरियम अवधि उपलब्ध",
      product6Feature3: "धारा 80ई के तहत कर लाभ",
      product6Button: "ऋण के लिए आवेदन करें",

      insuranceTitle: "बीमा उत्पादों की विस्तृत श्रृंखला",
      insuranceSubtitle: "हमारे व्यापक बीमा समाधानों के साथ सबसे महत्वपूर्ण को सुरक्षित रखें",
      insurance1Title: "जीवन बीमा",
      insurance1Desc: "विश्वसनीय जीवन बीमा योजनाओं के साथ अपने प्रियजनों के भविष्य को सुरक्षित करें।",
      insurance1Price: "₹450/माह* से शुरू",
      insurance1Button: "कोट प्राप्त करें",

      insurance2Title: "स्वास्थ्य बीमा",
      insurance2Desc: "सर्वोत्तम कवरेज के साथ सुनिश्चित करना कि आपका स्वास्थ्य अच्छे हाथों में है।",
      insurance2Price: "₹450/माह* से शुरू",
      insurance2Button: "योजनाओं की तुलना करें",

      insurance3Title: "सामान्य बीमा",
      insurance3Desc: "बीमा को आसान बनाया गया - वाहनों, यात्रा और बहुत कुछ के लिए आपकी सुरक्षा, हमारी विशेषज्ञता।",
      insurance3Price: "₹450/माह* से शुरू",
      insurance3Button: "अब अन्वेषण करें",

      processTitle: "आसान। सुविधाजनक। तेज़।",
      processSubtitle: "90% सफलता दर के साथ आपके ऋण के लिए सरल और त्वरित चरण",
      step1Title: "पात्रता जांचें",
      step1Desc: "हमें अपनी आवश्यकता बताएं। हमारी एआई 90+ मानदंडों के आधार पर सर्वोत्तम बैंकों से मेल खाती है।",
      step2Title: "ऑफ़र की तुलना करें",
      step2Desc: "100+ ऋणदाताओं से व्यक्तिगत ऋण विकल्पों को साइड बाय साइड देखें।",
      step3Title: "डिजिटल रूप से आवेदन करें",
      step3Desc: "आवेदन पूरा करें और दस्तावेज सीधे चयनित बैंकों को जमा करें।",
      step4Title: "भुगतान प्राप्त करें",
      step4Desc: "सप्ताहों के भीतर नहीं, बल्कि घंटों के भीतर त्वरित अनुमोदन और भुगतान प्राप्त करें।",

      dsaTitle: "डीएसए पार्टनर बनें",
      dsaSubtitle: "भारत के सबसे तेजी से बढ़ते ऋण वितरण नेटवर्क में शामिल हों और आकर्षक कमीशन कमाना शुरू करें",
      dsaDescription: "लोन एजेंट, पूर्व बैंकर, वित्तीय विश्लेषक, बीमा एजेंट, म्यूचुअल फंड एजेंट, चार्टर्ड एकाउंटेंट, बिल्डर या किसी अन्य क्षेत्र के पेशेवर हमारे साथ भागीदार बन सकते हैं।",
      benefit1Title: "आकर्षक कमीशन",
      benefit1Desc: "प्रत्येक सफल ऋण भुगतान पर प्रतिस्पर्धी कमीशन कमाएं।",
      benefit2Title: "व्यापक प्रशिक्षण",
      benefit2Desc: "उत्पादों, प्रक्रियाओं और बिक्री तकनीकों पर विस्तृत प्रशिक्षण प्राप्त करें।",
      benefit3Title: "समर्पित समर्थन",
      benefit3Desc: "पूरी प्रक्रिया में आपकी और आपके ग्राहकों की सहायता के लिए 24/7 समर्थन टीम।",
      dsaButton: "पार्टनर के रूप में पंजीकरण करें",

      teamTitle: 'टीम से मिलें',  // Hindi for 'Meet the team'
      teamMembers: [
        {
          name: 'श्री राकेश पांचाल',
          position: 'संस्थापक',
          photo: '/avatars/ceo.png'
        },
        {
          name: 'Lauren Pybus',
          position: 'वीपी ग्रोथ एंड डेवलपमेंट',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Raelen Thomas',
          position: 'वीपी फाइनेंस ऑपरेशंस',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Mitchell Fawcett',
          position: 'वीपी स्ट्रैटेजी',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Jieu Segal',
          position: 'वीपी सेल्स एंड मार्केटिंग',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Darren Maher',
          position: 'क्रिएटिव डायरेक्टर',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Ben Van Exan',
          position: 'सीनियर अकाउंट एग्जीक्यूटिव',
          photo: '/avatars/amit.png'
        },
        {
          name: 'John Blown',
          position: 'फाउंडिंग पार्टनर',
          photo: '/avatars/amit.png'
        },
      ],

      faqTitle: "अक्सर पूछे जाने वाले प्रश्न",
      faqSubtitle: "हमारी सेवाओं और प्रक्रियाओं के बारे में सामान्य प्रश्नों के उत्तर खोजें",
      faq1Question: "कृष्णा फिनकॉन्सेप्ट सर्विसेज क्या है और यह कैसे काम करता है?",
      faq1Answer: "कृष्णा फिनकॉन्सेप्ट सर्विसेज एक व्यापक वित्तीय सेवा प्लेटफॉर्म है जो ग्राहकों को लोन, क्रेडिट कार्ड और बीमा के लिए 100+ बैंकिंग भागीदारों से जोड़ता है। हम आपको सर्वोत्तम ऑफ़र से मिलाने, पात्रता जांच में मदद करने और डिजिटल दस्तावेज़ जमा करने की सुविधा के लिए एआई का उपयोग करते हैं।",
      faq2Question: "क्या मेरी व्यक्तिगत और वित्तीय जानकारी सुरक्षित है?",
      faq2Answer: "हां, हम सख्त सुरक्षा प्रोटोकॉल का पालन करते हैं और सभी डेटा संरक्षण विनियमों का अनुपालन करते हैं। हम आपके बैंक लॉगिन क्रेडेंशियल्स कभी स्टोर नहीं करते हैं और केवल आपके आवेदन के प्रसंस्करण के लिए आपकी स्पष्ट सहमति के साथ ऋणदाताओं के साथ जानकारी साझा करते हैं।",
      faq3Question: "मैं डीएसए पार्टनर कैसे बन सकता हूं?",
      faq3Answer: "पैन कार्ड और आधार कार्ड वाला कोई भी 25+ आयु वर्ग का व्यक्ति भागीदार बन सकता है। वित्त, रियल एस्टेट, बीमा या किसी भी क्षेत्र के पेशेवर शामिल हो सकते हैं। हम पूर्ण प्रशिक्षण, विपणन सहायता और समय पर कमीशन भुगतान प्रदान करते हैं।",
      faq4Question: "क्या आप सभी भारतीय बैंकों का समर्थन करते हैं?",
      faq4Answer: "हम एचडीएफसी, आईसीआईसीआई, एसबीआई, एक्सिस, कोटक, बजाज फिनसर्व और कई अन्य सहित 100+ प्रमुख बैंकों और एनबीएफसी के साथ सहयोग करते हैं। हालांकि हम हर एक बैंक को कवर नहीं करते हैं, लेकिन हम भारत की सभी प्रमुख वित्तीय संस्थाओं के साथ काम करते हैं।",





      testimonialTitle: 'हमारे ग्राहक क्या कहते हैं',
      testimonialSubtitle: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज के साथ अपने अनुभव के बारे में हमारे संतुष्ट ग्राहकों की सुनें',
      testimonials: [
        { name: 'अमित शर्मा', photo: '/avatars/amit.png', rating: 5, text: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज ने मेरे होम लोन को इतना आसान बना दिया! उत्कृष्ट सेवा और तेज़ स्वीकृति।' },
        { name: 'प्रिया पटेल', photo: '/avatars/priya.png', rating: 5, text: 'बहुत सारे विकल्पों वाला शानदार प्लेटफॉर्म। मुझे पर्सनल लोन के लिए सबसे अच्छी ब्याज दर मिली।' },
        { name: 'राहुल वर्मा', photo: '/avatars/rahul.png', rating: 4, text: 'DSA पार्टनर के रूप में, कृष्णा फिनकॉन्सेप्ट सर्विसेज ने समय पर कमीशन और बेहतरीन सपोर्ट से मेरी कमाई बढ़ाई है।' },
        { name: 'स्नेहा गुप्ता', photo: '/avatars/sneha.png', rating: 5, text: 'तेज़ और परेशानी-मुक्त हेल्थ इंश्योरेंस। डायरेक्ट खरीदारी की तुलना में बहुत बचत हुई!' },
        { name: 'विक्रम सिंह', photo: '/avatars/vikram.png', rating: 5, text: 'उपयोगकर्ता-अनुकूल EMI कैलकुलेटर और बिजनेस लोन आवेदन की सहज प्रक्रिया।' }
      ],

      partnersTitle: "हमारे बैंकिंग भागीदार",
      partnersSubtitle: "भारत के अग्रणी वित्तीय संस्थानों द्वारा विश्वसनीय",

      // Contact Us Section
      contactHeading: 'हमसे संपर्क करें',
      contactDesc: 'प्रश्न हैं? ऋण, बीमा या भागीदारी अवसरों पर व्यक्तिगत सहायता के लिए हमसे संपर्क करें।',
      phoneTitle: 'हमें कॉल करें',
      phoneDesc: '9909002220\सोम-शनि: सुबह 9-रात 9 | रवि: सुबह 10-शाम 6',
      emailTitle: 'हमें ईमेल करें',
      emailDesc: 'krishnafinconcept09@gmail.com',
      formHeading: 'हमें संदेश भेजें',
      nameLabel: 'आपका नाम',
      emailLabel: 'आपका ईमेल',
      phoneLabel: 'आपका फोन',
      messageLabel: 'आपका संदेश',
      termsText: 'मैं गोपनीयता नीति और उपयोग की शर्तों से सहमत हूं',
      submitButton: 'जमा करें',

      // Banking Partners Section
      bankHeading: 'हमारे भागीदार बैंक और NBFC',
      bankDesc: 'हम आपको सबसे अच्छे डील्स लाने के लिए 100+ बैंकों और NBFC के साथ भागीदारी करते हैं।',
      viewAll: 'सभी देखें',

      footerAbout: "कृष्णा फिनकॉन्सेप्ट सर्विसेज",
      footerDescription: "भारत का अग्रणी वित्तीय सेवा प्लेटफॉर्म, ग्राहकों को लोन, क्रेडिट कार्ड, बीमा और निवेश उत्पादों के लिए 100+ बैंकिंग भागीदारों से जोड़ता है।",
      footerProducts: "ऋण उत्पाद",
      footerHome: "होम लोन",
      footerPersonal: "पर्सनल लोन",
      footerBusiness: "बिजनेस लोन",
      footerLap: "प्रॉपर्टी के खिलाफ लोन",
      footerCar: "कार लोन",
      footerEducation: "शिक्षा ऋण",
      footerServices: "अन्य सेवाएं",
      footerCredit: "क्रेडिट कार्ड",
      footerInsurance: "बीमा",
      footerGold: "गोल्ड लोन",
      footerBills: "बिल भुगतान",
      footerCreditScore: "मुफ्त क्रेडिट स्कोर",
      footerPartner: "भागीदार बनें",
      footerContact: "हमसे संपर्क करें",
      footerPhone: "9909002220",
      footerEmail: "krishnafinconcept09@gmail.com",
      footerAddress: "भारत के 4,000+ शहरों में उपलब्ध",
      footerTiming: "सोम-शनि: सुबह 9-रात 9 | रवि: सुबह 10-शाम 6",
      copyrightText: "© 2025 कृष्णा फिनकॉन्सेप्ट सर्विसेज फाइनेंशियल सर्विसेज। सभी अधिकार सुरक्षित।",
      privacyLink: "गोपनीयता नीति",
      termsLink: "नियम एवं शर्तें",
      disclaimerLink: "डिस्क्लेमर"
    },
    // FULL gujarati translation object (replace the entire gujarati: { ... } in your translations)

    gujarati: {
      logo: "ફિનલિંક",
      navHome: "હોમ",
      navServices: "સેવાઓ",
      navAbout: 'અમારા વિશે',
      navDsa: "ભાગીદાર બનો",

      navFaq: "પ્રશ્નો-જવાબો",
      navContact: "સંપર્ક કરો",
      navCareer: 'કારકિર્દી અમારી સાથે',
      navHelp: 'હેલ્પ ડેસ્ક',
      partnerButton: "લૉગિન",
      applyButton: "DSA બની જાઓ",

      heroTitleLine1: "ભારતની અગ્રણી લોન",
      heroTitleLine2: "અને નાણાકીય સેવા પ્લેટફોર્મ",
      heroDescription: "100+ બેંકિંગ ભાગીદારો સાથે હોમ લોન, પર્સનલ લોન, બિઝનેસ લોન, ક્રેડિટ કાર્ડ, બીમા અને ઘણું બધું માટે જોડાઓ. તાત્કાલિક પાત્રતા તપાસ અને ડિજિટલ દસ્તાવેજ સબમિશન સાથે શ્રેષ્ઠ દરો મેળવો.",
      exploreButton: "પાત્રતા તપાસો",
      cibilButton: "CIBIL સ્કોર તપાસો",

      statExpText: "વર્ષોનો અનુભવ",
      statPartnersText: "બેંકિંગ ભાગીદારો",
      statFreelancersText: "ફ્રીલાન્સર્સ",
      statCustomersText: "સંતોષિત ગ્રાહક",

      productsTitle: "અમે નાણાકીય ઉત્પાદનોની વિશાળ શ્રેણી સુવિધાજનક બનાવીએ છીએ",
      productsSubtitle: "જે તમારા ગ્રાહકની જરૂરિયાતોને અનુરૂપ છે! અમારી વ્યાપક નાણાકીય ઉકેલોમાંથી પસંદ કરો",

      product1Title: "હોમ લોન",
      product1Desc: "તમારું સ્વપ્નનું ઘર રાહ જોઈ રહ્યું છે - લવચીક વિકલ્પો સાથે અમારી હોમ લોન ઉત્પાદનોની શ્રેણીનું અન્વેષણ કરો.",
      product1Feature1: "8.5% થી શરૂ થતા સૌથી નીચા વ્યાજ દરો",
      product1Feature2: "મિલ્કત મૂલ્યનો 90% સુધી",
      product1Feature3: "30 વર્ષ સુધીની લાંબી મુદત",
      product1Button: "પાત્રતા તપાસો",

      product2Title: "પર્સનલ લોન",
      product2Desc: "બધી જરૂરિયાતો માટે અમારા બહુમુખી પર્સનલ લોન વિકલ્પો સાથે તમારા સપનાને હાંસલ કરો.",
      product2Feature1: "₹40 લાખ સુધીની રકમ",
      product2Feature2: "24 કલાકમાં તાત્કાલિક મંજૂરી",
      product2Feature3: "કોઈ જામીનગીરી જરૂરી નથી",
      product2Button: "હમણાં અરજી કરો",

      product3Title: "મિલકત સામે લોન",
      product3Desc: "આકર્ષક દરે તૈયાર થયેલા લોન ઉકેલો સાથે તમારી મિલકતની કિંમત અનલૉક કરો.",
      product3Feature1: "ઉચ્ચ મૂલ્યના લોન ઉપલબ્ધ",
      product3Feature2: "સૌથી નીચા વ્યાજ દરો",
      product3Feature3: "લવચીક માફક પરત ચૂકવણી વિકલ્પો",
      product3Button: "ઑફર મેળવો",

      product4Title: "બિઝનેસ લોન",
      product4Desc: "અમારા લવચીક નાણાંકીય વિકલ્પો અને ઝડપી ચૂકવણી સાથે તમારા વ્યવસાયની વૃદ્ધિને વેગ આપો.",
      product4Feature1: "₹2 કરોડ સુધી",
      product4Feature2: "ન્યૂનતમ દસ્તાવેજીકરણ",
      product4Feature3: "જામીનગીરી મુક્ત વિકલ્પો",
      product4Button: "વ્યવસાયને વેગ આપો",

      product5Title: "કાર લોન",
      product5Desc: "નવી અને જૂની વાહનો માટે અમારા ઝડપી અને લવચીક કાર લોન સાથે તમારી સ્વપ્નની કાર ચલાવો.",
      product5Feature1: "100% ઓન-રોડ ફંડિંગ",
      product5Feature2: "પ્રતિસ્પર્ધી વ્યાજ દરો",
      product5Feature3: "ઝડપી પ્રોસેસિંગ",
      product5Button: "ઑફર તપાસો",

      product6Title: "એજ્યુકેશન લોન",
      product6Desc: "ઘરેલું અને આંતરરાષ્ટ્રીય અભ્યાસ માટે અમારી વિશિષ્ટ શિક્ષણ લોન સાથે તમારા બાળકના ભવિષ્યમાં રોકાણ કરો.",
      product6Feature1: "ટ્યૂશન + રહેવાનો ખર્ચ આવરી લે છે",
      product6Feature2: "મોરેટોરિયમ અવધિ ઉપલબ્ધ",
      product6Feature3: "કલમ 80ઈ હેઠળ કર લાભ",
      product6Button: "લોન માટે અરજી કરો",

      insuranceTitle: "બીમા ઉત્પાદનોની વિશાળ શ્રેણી",
      insuranceSubtitle: "અમારા વ્યાપક બીમા ઉકેલો સાથે જે સૌથી વધુ મહત્વનું છે તેને સુરક્ષિત કરો",
      insurance1Title: "જીવન બીમા",
      insurance1Desc: "વિશ્વસનીય જીવન બીમા યોજનાઓ સાથે તમારા પ્રિયજનોના ભવિષ્યને સુરક્ષિત કરો.",
      insurance1Price: "₹450/મહિના* થી શરૂ",
      insurance1Button: "કોટ મેળવો",

      insurance2Title: "સ્વાસ્થ્ય બીમા",
      insurance2Desc: "શ્રેષ્ઠ કવરેજ સાથે તમારા સ્વાસ્થ્ય સારા હાથમાં છે તેની ખાતરી કરવી.",
      insurance2Price: "₹450/મહિના* થી શરૂ",
      insurance2Button: "યોજનાઓની તુલના કરો",

      insurance3Title: "સામાન્ય બીમા",
      insurance3Desc: "બીમા સરળ બનાવ્યું - વાહનો, મુસાફરી અને ઘણું બધું માટે તમારું સુરક્ષા, અમારી નિષ્ણાતતા.",
      insurance3Price: "₹450/મહિના* થી શરૂ",
      insurance3Button: "હવે અન્વેષણ કરો",

      processTitle: "સરળ. સુવિધાજનક. ઝડપી.",
      processSubtitle: "90% સફળતા દર સાથે તમારા લોન માટે સરળ અને ઝડપી પગલાં",
      step1Title: "પાત્રતા તપાસો",
      step1Desc: "અમને તમારી જરૂરિયાત જણાવો. અમારી એઆઈ 90+ માપદંડોના આધારે શ્રેષ્ઠ બેંકો સાથે મેળ ખાય છે.",
      step2Title: "ઑફરની તુલના કરો",
      step2Desc: "100+ લોનદાતાઓમાંથી વ્યક્તિગત લોન વિકલ્પોને સાઇડ બાય સાઇડ જુઓ.",
      step3Title: "ડિજિટલ રીતે અરજી કરો",
      step3Desc: "એપ્લિકેશન પૂર્ણ કરો અને દસ્તાવેજો સીધા પસંદ કરેલી બેંકોને સબમિટ કરો.",
      step4Title: "ચુકવણી મેળવો",
      step4Desc: "અઠવાડિયામાં નહીં પરંતુ કલાકોની અંદર ઝડપી મંજૂરી અને ચુકવણી મેળવો.",

      dsaTitle: "ડીએસએ ભાગીદાર બનો",
      dsaSubtitle: "ભારતના સૌથી ઝડપી વધતા લોન વિતરણ નેટવર્કમાં જોડાઓ અને આકર્ષક કમિશન કમાવાનું શરૂ કરો",
      dsaDescription: "લોન એજન્ટ, ભૂતપૂર્વ બેંકર, નાણાકીય વિશ્લેષકો, બીમા એજન્ટ, મ્યુચ્યુઅલ ફંડ એજન્ટ, ચાર્ટર્ડ એકાઉન્ટન્ટ, બિલ્ડર અથવા અન્ય કોઈપણ ક્ષેત્રના વ્યવસાયિકો કોઈપણ અમારા સાથે ભાગીદાર બની શકે છે.",
      benefit1Title: "આકર્ષક કમિશન",
      benefit1Desc: "દરેક સફળ લોન ચુકવણી પર સ્પર્ધાત્મક કમિશન કમાઓ.",
      benefit2Title: "વ્યાપક તાલીમ",
      benefit2Desc: "ઉત્પાદનો, પ્રક્રિયાઓ અને વેચાણ તકનીકો પર વિગતવાર તાલીમ મેળવો.",
      benefit3Title: "સમર્પિત આધાર",
      benefit3Desc: "સમગ્ર પ્રક્રિયામાં તમારી અને તમારા ગ્રાહકોની સહાય માટે 24/7 સપોર્ટ ટીમ.",
      dsaButton: "ભાગીદાર તરીકે નોંધણી કરો",

      teamTitle: 'ટીમને મળો',

      teamMembers: [
        {
          name: 'શ્રી રાકેશ પંચાલ',
          position: 'સ્થાપક',
          photo: '/avatars/ceo.png'
        },
        {
          name: 'Lauren Pybus',
          position: 'વીપી ગ્રોથ એન્ડ ડેવલપમેન્ટ',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Raelen Thomas',
          position: 'વીપી ફાઇનાન્સ ઓપરેશન્સ',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Mitchell Fawcett',
          position: 'વીપી સ્ટ્રેટેજી',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Jieu Segal',
          position: 'વીપી સેલ્સ એન્ડ માર્કેટિંગ',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Darren Maher',
          position: 'ક્રિએટિવ ડિરેક્ટર',
          photo: '/avatars/amit.png'
        },
        {
          name: 'Ben Van Exan',
          position: 'સિનિયર એકાઉન્ટ એક્ઝિક્યુટિવ',
          photo: '/avatars/amit.png'
        },
        {
          name: 'John Blown',
          position: 'ફાઉન્ડિંગ પાર્ટનર',
          photo: '/avatars/amit.png'
        },
      ],

      faqTitle: "વારંવાર પૂછાતા પ્રશ્નો",
      faqSubtitle: "અમારી સેવાઓ અને પ્રક્રિયાઓ વિશેના સામાન્ય પ્રશ્નોના જવાબો શોધો",
      faq1Question: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ શું છે અને તે કેવી રીતે કાર્ય કરે છે?",
      faq1Answer: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એક વ્યાપક નાણાકીય સેવા પ્લેટફોર્મ છે જે ગ્રાહકોને લોન, ક્રેડિટ કાર્ડ અને બીમા માટે 100+ બેંકિંગ ભાગીદારો સાથે જોડે છે. અમે તમને શ્રેષ્ઠ ઑફર સાથે મેચ કરવા, પાત્રતા તપાસમાં મદદ કરવા અને ડિજિટલ દસ્તાવેજ સબમિશનની સુવિધા માટે એઆઈનો ઉપયોગ કરીએ છીએ.",
      faq2Question: "શું મારી વ્યક્તિગત અને નાણાકીય માહિતી સુરક્ષિત છે?",
      faq2Answer: "હા, અમે કડક સુરક્ષા પ્રોટોકોલનું પાલન કરીએ છીએ અને તમામ ડેટા સંરક્ષણ નિયમોનું પાલન કરીએ છીએ. અમે તમારા બેંક લોગિન ક્રેડેન્શિયલ્સ ક્યારેય સંગ્રહિત કરતા નથી અને ફક્ત તમારી એપ્લિકેશન પ્રોસેસિંગ માટે તમારી સ્પષ્ટ સંમતિ સાથે લોનદાતાઓ સાથે માહિતી શેર કરીએ છીએ.",
      faq3Question: "હું ડીએસએ ભાગીદાર કેવી રીતે બની શકું?",
      faq3Answer: "પૅન કાર્ડ અને આધાર કાર્ડ ધરાવતા 25+ વર્ષની ઉંમરના કોઈપણ વ્યક્તિ ભાગીદાર બની શકે છે. નાણાં, રીઅલ એસ્ટેટ, બીમા અથવા કોઈપણ ક્ષેત્રના વ્યવસાયિકો જોડાઈ શકે છે. અમે સંપૂર્ણ તાલીમ, માર્કેટિંગ સહાય અને સમયસર કમિશન ચુકવણી પ્રદાન કરીએ છીએ.",
      faq4Question: "શું તમે બધા ભારતીય બેંકોને સપોર્ટ કરો છો?",
      faq4Answer: "અમે એચડીએફસી, આઈસીઆઈસીઆઈ, એસબીઆઈ, એક્સિસ, કોટક, બજાજ ફિનસર્વ અને ઘણા બધા સહિત 100+ પ્રમુખ બેંકો અને એનબીએફસી સાથે સહયોગ કરીએ છીએ. જ્યારે અમે દરેક એક બેંકને કવર કરતા નથી, પરંતુ અમે ભારતની તમામ પ્રમુખ નાણાકીય સંસ્થાઓ સાથે કામ કરીએ છીએ.",

      testimonialTitle: 'અમારા ગ્રાહકો શું કહે છે',
      testimonialSubtitle: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ સાથેના તેમના અનુભવ વિશે અમારા સંતુષ્ટ ગ્રાહકો પાસેથી સાંભળો',
      testimonials: [
        { name: 'અમિત શર્મા', photo: '/avatars/amit.png', rating: 5, text: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એ મારી હોમ લોનને ખૂબ સરળ બનાવી! ઉત્તમ સેવા અને ઝડપી મંજૂરી.' },
        { name: 'પ્રિયા પટેલ', photo: '/avatars/priya.png', rating: 5, text: 'ઘણા વિકલ્પો સાથેનું શાનદાર પ્લેટફોર્મ. મને પર્સનલ લોન માટે શ્રેષ્ઠ વ્યાજ દર મળ્યો.' },
        { name: 'રાહુલ વર્મા', photo: '/avatars/rahul.png', rating: 4, text: 'DSA પાર્ટનર તરીકે, કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એ સમયસર કમિશન અને શાનદાર સપોર્ટથી મારી કમાણી વધારી છે.' },
        { name: 'સ્નેહા ગુપ્તા', photo: '/avatars/sneha.png', rating: 5, text: 'ઝડપી અને મુશ્કેલી-મુક્ત હેલ્થ ઇન્શ્યોરન્સ. ડાયરેક્ટ ખરીદીની તુલનાએ ઘણી બચત થઈ!' },
        { name: 'વિક્રમ સિંહ', photo: '/avatars/vikram.png', rating: 5, text: 'યુઝર-ફ્રેન્ડલી EMI કેલ્ક્યુલેટર અને બિઝનેસ લોન અરજીની સરળ પ્રક્રિયા.' }
      ],

      partnersTitle: "અમારા બેંકિંગ ભાગીદારો",
      partnersSubtitle: "ભારતની અગ્રણી નાણાકીય સંસ્થાઓ દ્વારા વિશ્વસનીય",

      // Contact Us Section
      contactHeading: 'અમારો સંપર્ક કરો',
      contactDesc: 'પ્રશ્નો છે? લોન, વીમા અથવા ભાગીદારી તકો પર વ્યક્તિગત સહાય માટે અમારો સંપર્ક કરો.',
      phoneTitle: 'અમને કૉલ કરો',
      phoneDesc: '9909002220\nસોમ-શનિ: સવાર 9-રાત 9 | રવિ: સવાર 10-સાંજ 6',
      emailTitle: 'અમને ઈમેઇલ કરો',
      emailDesc: 'krishnafinconcept09@gmail.com',
      formHeading: 'અમને સંદેશ મોકલો',
      nameLabel: 'તમારું નામ',
      emailLabel: 'તમારું ઈમેઇલ',
      phoneLabel: 'તમારો ફોન',
      messageLabel: 'તમારો સંદેશ',
      termsText: 'હું ગોપનીયતા નીતિ અને વપરાશની શરતો સાથે સંમત છું',
      submitButton: 'સબમિટ કરો',

      // Banking Partners Section
      bankHeading: 'અમારા ભાગીદાર બેંક અને NBFC',
      bankDesc: 'અમે તમને શ્રેષ્ઠ ડીલ્સ લાવવા માટે 100+ બેંકો અને NBFC સાથે ભાગીદારી કરીએ છીએ.',
      viewAll: 'બધા જુઓ',

      footerAbout: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ",
      footerDescription: "ભારતનું અગ્રણી નાણાકીય સેવા પ્લેટફોર્મ, ગ્રાહકોને લોન, ક્રેડિટ કાર્ડ, બીમા અને રોકાણ ઉત્પાદનો માટે 100+ બેંકિંગ ભાગીદારો સાથે જોડે છે.",
      footerProducts: "લોન ઉત્પાદનો",
      footerHome: "હોમ લોન",
      footerPersonal: "પર્સનલ લોન",
      footerBusiness: "બિઝનેસ લોન",
      footerLap: "મિલકત સામે લોન",
      footerCar: "કાર લોન",
      footerEducation: "એજ્યુકેશન લોન",
      footerServices: "અન્ય સેવાઓ",
      footerCredit: "ક્રેડિટ કાર્ડ",
      footerInsurance: "બીમા",
      footerGold: "ગોલ્ડ લોન",
      footerBills: "બિલ પેમેન્ટ",
      footerCreditScore: "મફત ક્રેડિટ સ્કોર",
      footerPartner: "ભાગીદાર બનો",
      footerContact: "અમારો સંપર્ક કરો",
      footerPhone: "9909002220",
      footerEmail: "krishnafinconcept09@gmail.com",
      footerAddress: "ભારતના 4,000+ શહેરોમાં ઉપલબ્ધ",
      footerTiming: "સોમ-શનિ: સવાર 9-રાત 9 | રવિ: સવાર 10-સાંજ 6",
      copyrightText: "© 2025 કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ નાણાકીય સેવાઓ. બધા હક્કો આરક્ષિત.",
      privacyLink: "ગોપનીયતા નીતિ",
      termsLink: "નિયમો અને શરતો",
      disclaimerLink: "નિરાકરણ"
    }
  };

  const t = translations[currentLanguage];



  const toggleFaq = (index) => {
    setOpenFaqs(prev => ({ ...prev, [index]: !prev[index] }));
  };


  const handleContactInputChange = (e) => {
    const { name, value } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle loan type change specifically
  const handleLoanTypeChange = (e) => {
    const selectedValue = e.target.value;
    console.log('Selected loan type:', selectedValue);

    setContactForm(prev => ({
      ...prev,
      loan_type: selectedValue
    }));
  };

  // API Submission function
  const handleContactSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!contactForm.fullname || !contactForm.email || !contactForm.mobile || !contactForm.main_product || !contactForm.sub_product) {
      setSubmitMessage('Please fill in all required fields');
      setSubmitStatus('error');
      return;
    }

    // Add this validation after the existing validations
    const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
    if (contactForm.pan_number && contactForm.pan_number.trim() !== '' && !panRegex.test(contactForm.pan_number.toUpperCase())) {
      setSubmitMessage('Please enter a valid PAN number (Format: ABCDE1234F)');
      setSubmitStatus('error');
      return;
    }

    // Phone number validation (10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(contactForm.mobile) || (isSecondMobileOpen && contactForm.secondary_mobile.length > 0 && !phoneRegex.test(contactForm.secondary_mobile))) {
      setSubmitMessage('Please enter a valid 10-digit mobile number');
      setSubmitStatus('error');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(contactForm.email) || (isSecondEmailOpen && contactForm.secondary_email.length > 0 && !emailRegex.test(contactForm.secondary_email))) {
      setSubmitMessage('Please enter a valid email address');
      setSubmitStatus('error');
      return;
    }



    if (contactForm.email === contactForm.secondary_email && contactForm.secondary_email.length > 0) {
      setSubmitMessage('Primary and secondary email addresses cannot be the same.');
      setSubmitStatus('error');
      return;
    }

    if (contactForm.mobile === contactForm.secondary_mobile && contactForm.secondary_mobile.length > 0) {
      setSubmitMessage('Primary and secondary mobile numbers cannot be the same.');
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');
    console.log('Submitting contact form:', contactForm);
    try {
      // In your handleContactSubmit function, update the formData preparation
      const formData = {
        fullname: contactForm.fullname,
        pan_number: contactForm.pan_number.toUpperCase() || null,
        email: contactForm.email,
        secondary_email: contactForm.secondary_email || '',
        mobile: contactForm.mobile,
        secondary_mobile: contactForm.secondary_mobile || '',
        main_product: contactForm.main_product || null,
        sub_product: contactForm.sub_product || null,
        source: 'Website Contact Form',
        page_url: window.location.href
      };

      // Remove loan_type if it's empty string
      if (formData.loan_type === '') {
        delete formData.loan_type;
      }

      console.log('Sending data to API:', formData);

      // Use the API URL
      const apiUrl = process.env.REACT_APP_API_URL || 'https://kfs09.in/api';

      const response = await fetch(`${apiUrl}/v1/contact/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      console.log('Response status:', response.status);

      const result = await response.json();
      console.log('Response data:', result);

      // In your handleContactSubmit function, after successful submission:
      if (response.ok) {
        const successMsg = result.message || 'Thank you! Your inquiry has been submitted successfully.';
        const fullMessage = successMsg; // Just show the success message without reference ID


        // Store in localStorage
        localStorage.setItem('contactFormMessage', fullMessage);
        localStorage.setItem('contactFormStatus', 'success');

        setSubmitMessage(fullMessage);
        setSubmitStatus('success');




        // Show reference ID if available
        if (result.data && result.data.reference_id) {
          console.log('Reference ID:', result.data.reference_id);
        }

        // Show PDF URL if available
        if (result.data && result.data.pdf_url) {
          console.log('PDF Document:', result.data.pdf_url);
        }

        // Reset form on successful submission
        setContactForm({
          fullname: '',
          pan_number: '',
          email: '',
          mobile: '',
          loan_type: '',
          insurance_type: '',
          secondary_email: '',
          secondary_mobile: '',
          main_product: '',
          sub_product: ''
        });


      } else {
        console.error('API Error Details:', {
          status: response.status,
          statusText: response.statusText,
          errors: result.errors,
          message: result.message
        });

        // Use the helper function for contact form errors too
        if (result.errors) {
          const formattedErrors = formatBackendErrors(result.errors);
          throw new Error(formattedErrors);
        }

        throw new Error(result.message || `Submission failed (${response.status})`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);

      let errorMessage = error.message || 'Something went wrong. Please try again.';

      // Provide user-friendly error messages
      if (error.message.includes('Loan Type Error')) {
        errorMessage = 'Please select a valid loan type from the list.';
      } else if (error.message.includes('422')) {
        errorMessage = 'Please check your information and try again.';
      } else if (error.message.includes('network')) {
        errorMessage = 'Network error. Please check your connection.';
      }

      setSubmitMessage(errorMessage);
      setSubmitStatus('error');

      // Store error in localStorage
      localStorage.setItem('contactFormMessage', errorMessage);
      localStorage.setItem('contactFormStatus', 'error');


    } finally {
      setIsSubmitting(false);
    }
  };







  // ========== ADD THIS FUNCTION HERE ==========
  // Add this function to capture selfie
  const captureSelfie = (setter) => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'user',
          width: { ideal: 1280 },
          height: { ideal: 720 }
        },
        audio: false
      })
        .then((stream) => {
          const video = document.createElement('video');
          video.srcObject = stream;
          video.play();

          const cameraModal = document.createElement('div');
          cameraModal.className = 'camera-modal';
          cameraModal.innerHTML = `
        <div class="camera-modal-content">
          <div class="camera-header">
            <h3>Take Selfie</h3>
            <button class="close-camera">&times;</button>
          </div>
          <div class="camera-feed">
            <video id="cameraView" autoplay playsinline></video>
          </div>
          <div class="camera-controls">
            <button id="captureBtn" class="capture-btn">📸 Capture</button>
            <button id="retakeBtn" class="retake-btn" style="display:none;">🔄 Retake</button>
          </div>
        </div>
      `;

          document.body.appendChild(cameraModal);
          const videoElement = cameraModal.querySelector('#cameraView');
          videoElement.srcObject = stream;

          cameraModal.querySelector('#captureBtn').onclick = () => {
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(videoElement, 0, 0);

            // Create preview URL
            const previewUrl = canvas.toDataURL('image/jpeg', 0.9);
            setSelfiePreviewUrl(previewUrl);

            canvas.toBlob((blob) => {
              const file = new File([blob], `selfie_${Date.now()}.jpg`, {
                type: 'image/jpeg',
                lastModified: Date.now()
              });

              // Set the file
              if (setter) {
                setter(file);
              } else {
                setSelfiePhoto(file);
              }

              // Stop camera and remove modal
              stream.getTracks().forEach(track => track.stop());
              cameraModal.remove();

            }, 'image/jpeg', 0.9);
          };

          cameraModal.querySelector('.close-camera').onclick = () => {
            stream.getTracks().forEach(track => track.stop());
            cameraModal.remove();
          };
        })
        .catch((error) => {
          alert('Camera access denied. Please allow camera permission to take a selfie.');
          console.error('Camera error:', error);

          // Fallback to file upload
          const fileInput = document.createElement('input');
          fileInput.type = 'file';
          fileInput.accept = 'image/*';
          fileInput.onchange = (e) => {
            if (e.target.files && e.target.files[0]) {
              const file = e.target.files[0];
              if (setter) {
                setter(file);
              } else {
                setSelfiePhoto(file);
              }

              // Create preview for uploaded file
              const reader = new FileReader();
              reader.onload = (event) => {
                setSelfiePreviewUrl(event.target.result);
              };
              reader.readAsDataURL(file);
            }
          };
          fileInput.click();
        });
    } else {
      alert('Camera not available on this device. Please upload a photo instead.');

      // Fallback to file upload
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = 'image/*';
      fileInput.onchange = (e) => {
        if (e.target.files && e.target.files[0]) {
          const file = e.target.files[0];
          if (setter) {
            setter(file);
          } else {
            setSelfiePhoto(file);
          }

          // Create preview for uploaded file
          const reader = new FileReader();
          reader.onload = (event) => {
            setSelfiePreviewUrl(event.target.result);
          };
          reader.readAsDataURL(file);
        }
      };
      fileInput.click();
    }
  };











  // Add these functions to your Home component

  // Handle DSA form input changes
  const handleDsaInputChange = (field, value) => {
    setDsaForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle pincode change with debouncing
  const handlePincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    handleDsaInputChange('pincode', value);

    // Clear city and state if pincode is less than 6 digits
    if (value.length < 6) {
      setDsaForm(prev => ({
        ...prev,
        city: '',
        state: ''
      }));
    }
  };

  // Handle pincode blur (when user leaves the field)
  const handlePincodeBlur = async (e) => {
    const pincode = e.target.value.trim();

    if (pincode.length === 6) {
      await fetchLocationFromPincode(pincode);
    }
  };

  // Fetch location data from pincode
  const fetchLocationFromPincode = async (pincode) => {
    if (!pincode || pincode.length !== 6) return;

    setIsLoadingLocation(true);

    try {
      // Using India Post API (free and reliable)
      const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await response.json();

      if (data[0].Status === "Success") {
        const postOffice = data[0].PostOffice[0];

        setDsaForm(prev => ({
          ...prev,
          city: postOffice.District || postOffice.Name,
          state: postOffice.State,
          area: postOffice.Name
        }));

      } else {
        // Fallback to manual entry
        setDsaForm(prev => ({
          ...prev,
          city: '',
          state: '',
          area: ''
        }));

        // Show message to enter manually
        alert('Pincode not found. Please enter city and state manually.');
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);

      // Alternative API fallback
      try {
        const fallbackResponse = await fetch(`https://api.zippopotam.us/in/${pincode}`);
        const fallbackData = await fallbackResponse.json();

        if (fallbackData.places && fallbackData.places.length > 0) {
          const place = fallbackData.places[0];

          setDsaForm(prev => ({
            ...prev,
            city: place['place name'],
            state: place.state
          }));
        }
      } catch (fallbackError) {
        console.error('Fallback API also failed:', fallbackError);

        // Show message to enter manually
        alert('Unable to fetch location. Please enter city and state manually.');
      }
    } finally {
      setIsLoadingLocation(false);
    }
  };

  // Format file size for display
  const formatFileSize = (bytes) => {
    if (bytes === 0 || !bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  // Helper function to format backend errors with red X
  const formatBackendErrors = (errors) => {
    if (!errors || typeof errors !== 'object') {
      return '❌ An error occurred. Please try again.';
    }

    const errorMessages = [];

    // Handle Laravel validation errors
    Object.entries(errors).forEach(([field, messages]) => {
      if (Array.isArray(messages)) {
        const fieldLabel = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        // Add red X before each error
        messages.forEach(message => {
          errorMessages.push(`❌ ${fieldLabel}: ${message}`);
        });
      }
    });

    return errorMessages.join('\n');
  };


  // Handle DSA form submission
  const handleDsaSubmit = async (e) => {
    e.preventDefault();

    // First submit Step 3 data
    try {
      await submitStep3();
    } catch (error) {
      console.error('Step 3 submission failed:', error);

      // Show error in popup
      setDsaPopupMessage(`❌ Failed to submit documents: ${error.message}`);
      setDsaPopupType('error');
      setShowDsaPopup(true);

      // Auto-hide after 5 seconds
      setTimeout(() => {
        setShowDsaPopup(false);
      }, 5000);
      return;
    }

    // Final validation
    if (!validateCurrentStep()) {
      return;
    }

    // Additional validation for final submission
    if (!dsaForm.fullname || !dsaForm.pan || !dsaForm.email || !dsaForm.mobile) {
      setDsaPopupMessage('❌ Please complete all required personal information');
      setDsaPopupType('error');
      setShowDsaPopup(true);
      return;
    }

    if (!dsaForm.experience || !dsaForm.profession) {
      setDsaPopupMessage('❌ Please complete professional information');
      setDsaPopupType('error');
      setShowDsaPopup(true);
      return;
    }

    if (!selfiePhoto || !aadhaarFront || !aadhaarBack || !panCardPhoto || !cancelCheque) {
      setDsaPopupMessage('❌ Please upload all required documents');
      setDsaPopupType('error');
      setShowDsaPopup(true);
      return;
    }

    // Terms and conditions check
    const termsCheckbox = document.getElementById('agreeTerms');
    if (!termsCheckbox || !termsCheckbox.checked) {
      setDsaPopupMessage('❌ Please agree to the Terms & Conditions to proceed');
      setDsaPopupType('error');
      setShowDsaPopup(true);
      return;
    }

    setIsSubmitting(true);

    try {
      // Show loading in popup
      setDsaPopupMessage('⏳ Processing your application...');
      setDsaPopupType('info');
      setShowDsaPopup(true);

      // Create FormData object for logging/validation
      const formData = new FormData();

      // Personal Information
      formData.append('fullname', dsaForm.fullname);
      formData.append('pan', dsaForm.pan);
      formData.append('dob', dsaForm.dob);
      formData.append('email', dsaForm.email);
      formData.append('mobile', dsaForm.mobile);
      formData.append('gender', dsaForm.gender);
      formData.append('address', dsaForm.address);
      formData.append('pincode', dsaForm.pincode);
      formData.append('city', dsaForm.city);
      formData.append('state', dsaForm.state);
      formData.append('area', dsaForm.area);


      // Professional Information
      formData.append('experience', dsaForm.experience);
      formData.append('profession', dsaForm.profession);

      // Required Documents
      if (selfiePhoto) formData.append('selfie_photo', selfiePhoto);
      if (officePhoto) formData.append('office_photo', officePhoto);
      if (aadhaarFront) formData.append('aadhaar_front', aadhaarFront);
      if (aadhaarBack) formData.append('aadhaar_back', aadhaarBack);
      if (panCardPhoto) formData.append('pan_card_photo', panCardPhoto);
      if (cancelCheque) formData.append('cancel_cheque', cancelCheque);

      // Other Documents - FIXED
      const validOtherDocs = otherDocuments.filter(doc =>
        doc && (doc.text || doc.file) && (doc.text?.trim() || doc.file)
      );
      validOtherDocs.forEach((doc, index) => {
        if (doc.file) {
          formData.append(`other_documents[${index}][file]`, doc.file);
          formData.append(`other_documents[${index}][document_type]`, doc.type || 'other');
          formData.append(`other_documents[${index}][document_name]`, doc.name || `Document ${index + 1}`);
        } else if (doc.text && doc.text.trim()) {
          formData.append(`other_documents[${index}]`, doc.text);
        }
      });

      // Log form data for debugging
      console.log('DSA Form Data Summary:', {
        personalInfo: {
          fullname: dsaForm.fullname,
          email: dsaForm.email,
          mobile: dsaForm.mobile,
          pan: dsaForm.pan,
          dob: dsaForm.dob,
          gender: dsaForm.gender,
          address: dsaForm.address.substring(0, 50) + '...',
          pincode: dsaForm.pincode,
          city: dsaForm.city,
          state: dsaForm.state
        },
        professionalInfo: {
          experience: dsaForm.experience,
          profession: dsaForm.profession
        },
        documents: {
          selfie: selfiePhoto ? `${selfiePhoto.name} (${formatFileSize(selfiePhoto.size)})` : 'Missing',
          aadhaarFront: aadhaarFront ? `${aadhaarFront.name} (${formatFileSize(aadhaarFront.size)})` : 'Missing',
          aadhaarBack: aadhaarBack ? `${aadhaarBack.name} (${formatFileSize(aadhaarBack.size)})` : 'Missing',
          panCard: panCardPhoto ? `${panCardPhoto.name} (${formatFileSize(panCardPhoto.size)})` : 'Missing',
          cancelCheque: cancelCheque ? `${cancelCheque.name} (${formatFileSize(cancelCheque.size)})` : 'Missing',
          officePhoto: officePhoto ? `${officePhoto.name} (${formatFileSize(officePhoto.size)})` : 'Not uploaded',
          otherDocuments: validOtherDocs.length
        },
        timestamp: new Date().toISOString()
      });

      // Show loading animation
      const submitBtn = document.querySelector('.submit-dsa-btn');
      if (submitBtn) {
        submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Processing...';
        submitBtn.disabled = true;
      }

      // Simulate processing delay
      await new Promise(resolve => setTimeout(resolve, 1500));

      // Generate reference ID
      const referenceId = 'DSA' + Date.now().toString().slice(-8) + Math.random().toString(36).substr(2, 4).toUpperCase();

      // Show success popup
      setDsaPopupMessage('DSA Form Submitted Successfully!\nThank you for choosing Krishna Finconcept Services!');
      setDsaPopupType('success');
      setShowDsaPopup(true);

      // Store application data in localStorage (for demo purposes)
      const applicationData = {
        reference_id: referenceId,
        fullname: dsaForm.fullname,
        email: dsaForm.email,
        mobile: dsaForm.mobile,
        application_date: new Date().toISOString(),
        status: 'pending',
        steps_completed: 3
      };

      localStorage.setItem('dsaApplicationData', JSON.stringify(applicationData));
      localStorage.setItem('lastDSAReference', referenceId);

      // Reset form and close modal after a delay
      setTimeout(() => {
        resetDsaForm();
        setIsDSAFormOpen(false);
        setShowDsaPopup(false);
      }, 3000);

    } catch (error) {
      console.error('Error in DSA form submission:', error);

      // Extract error message - backend errors are already formatted
      let errorMessage = error.message || 'An error occurred. Please try again.';

      // Show error in popup
      setDsaPopupMessage(`❌ ${errorMessage}`);
      setDsaPopupType('error');
      setShowDsaPopup(true);

      // Reset button state
      const submitBtn = document.querySelector('.submit-dsa-btn');
      if (submitBtn) {
        submitBtn.innerHTML = '<i className="fas fa-paper-plane"></i> Submit Application';
        submitBtn.disabled = false;
      }

      // Auto-hide error popup after 5 seconds
      setTimeout(() => {
        setShowDsaPopup(false);
      }, 5000);

    } finally {
      setIsSubmitting(false);
    }
  };

  const resetDsaForm = () => {

    // Clear stored user ID
    localStorage.removeItem('dsa_user_id');

    // Reset form state
    setDsaForm({
      fullname: '',
      pan: '',
      dob: '',
      email: '',
      mobile: '',
      gender: '',
      address: '',
      pincode: '',
      city: '',
      state: '',
      area: '',
      experience: '',
      profession: '',
    });

    // Reset other state variables
    setGender('');
    setOtherDocuments(['']); // Reset to one empty field
    setAadhaarFront(null);
    setAadhaarBack(null);
    setPanCardPhoto(null);
    setCancelCheque(null);
    setOfficePhoto(null);
    setSelfiePhoto(null);
    setSelfiePreviewUrl('');
    setOfficePreviewUrl('');

    // Reset to first step
    setDsaStep(1);

    // Clear all file inputs in the form
    const fileInputs = document.querySelectorAll('.dsa-form input[type="file"]');
    fileInputs.forEach(input => {
      input.value = '';
    });

    // Clear all image previews
    const imagePreviews = document.querySelectorAll('.dsa-form .image-preview');
    imagePreviews.forEach(preview => {
      preview.innerHTML = '';
    });

    // Clear other document previews
    const otherDocPreviews = document.querySelectorAll('.other-document-preview');
    otherDocPreviews.forEach(preview => {
      preview.innerHTML = '';
    });

    // Reset terms checkbox
    const termsCheckbox = document.getElementById('agreeTerms');
    if (termsCheckbox) {
      termsCheckbox.checked = false;
    }

    // Reset progress bar active state
    const progressSteps = document.querySelectorAll('.progress-step');
    progressSteps.forEach((step, index) => {
      if (index === 0) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });

    // Reset validation states
    setIsLoadingLocation(false);

    // Reset submit button if exists
    const submitBtn = document.querySelector('.submit-dsa-btn');
    if (submitBtn) {
      submitBtn.innerHTML = '<i class="fas fa-paper-plane"></i> Submit Application';
      submitBtn.disabled = false;
    }

    // Reset next/previous buttons
    const nextBtn = document.querySelector('.next-btn');
    const prevBtn = document.querySelector('.prev-btn');
    if (nextBtn) nextBtn.disabled = false;
    if (prevBtn) prevBtn.disabled = false;

    console.log('✅ DSA form has been reset successfully');
  };

  const [hasAgreedTerms, setHasAgreedTerms] = useState(false);

  const checkTerms = (e) => {
    if (e.target.checked) {
      setHasAgreedTerms(true);
    } else {
      setHasAgreedTerms(false);
    }
  }

  return (
    <>


      {/* Mobile Menu Overlay */}
      {/* {isMobileMenuOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )} */}


      {/* Hero Section */}
      {/* <section id="home" className="hero">
        <div className="hero-content">
          <h1 className="typing-animation">
            {heroTitleLines.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < heroTitleLines.length - 1 && <br />}
              </React.Fragment>
            ))}
            <span className={`cursor ${isTypingComplete ? 'blink' : ''}`}>|</span>
          </h1>
          <p>{t.heroDescription}</p>
          <div className="hero-buttons">
            <button className="cta-button" onClick={() => navigate('/coming')}>{t.exploreButton}</button>
            <button className="secondary-button" onClick={() => navigate('/cibil')}>
              {t.cibilButton}
            </button>
          </div>
        </div>
      </section> */}

      <HeroSlider />







      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-grid">
          <div className="stat-item" onClick={() => { window.open('/year-experience', '_blank') }}>
            <div className="stat-number">
              {statCounters?.yearsExp?.toLocaleString('en-IN')}
              <span className="stat-plus">+</span>
            </div>
            <div className="stat-text">{t.statExpText}</div>
            <div className="stat-progress-bar">
              <div className="stat-progress-fill" style={{ width: '100%' }}></div>
            </div>
          </div>

          {/* ── CLICKABLE BANKING PARTNERS ── Opens in new tab */}
          <div
            className="stat-item clickable"
            onClick={() => window.open('/banking-partners', '_blank')}
            role="button"
            style={{ cursor: 'pointer' }}
          >
            <div className="stat-number">
              {statCounters?.partners?.toLocaleString('en-IN')}
              <span className="stat-plus">+</span>
            </div>
            <div className="stat-text">{t.statPartnersText}</div>
            <div className="stat-progress-bar">
              <div className="stat-progress-fill" style={{ width: '100%' }}></div>
            </div>
          </div>


          <div
            className="stat-item clickable"
            onClick={() => window.open('/freelancers', '_blank')}
            role="button"
            style={{ cursor: 'pointer' }}
          >
            <div className="stat-number">
              {statCounters?.freelancers?.toLocaleString('en-IN')}
              <span className="stat-plus">+</span>
            </div>
            <div className="stat-text">{t.statFreelancersText}</div>
            <div className="stat-progress-bar">
              <div className="stat-progress-fill" style={{ width: '100%' }}></div>
            </div>
          </div>

          <div className="stat-item" onClick={() => window.open('/satisfied-customers', '_blank')}>
            <div className="stat-number">
              {statCounters?.customers?.toLocaleString('en-IN')}
              <span className="stat-plus">+</span>
            </div>
            <div className="stat-text">{t.statCustomersText}</div>
            <div className="stat-progress-bar">
              <div className="stat-progress-fill" style={{ width: '100%' }}></div>
            </div>
          </div>
        </div>
      </section>












      {/* Products Section */}
      <section id="products" className="section">
        <div className="section-header">
          <h2>{t.productsTitle}</h2>
          <p>{t.productsSubtitle}</p>
        </div>
        <div className="products-grid">

          {/* Product 1 - Home Loan */}
          <div className="product-card" onClick={() => navigate('/home-loan')}>
            <div className="product-icon">🏠</div>
            <div className="interest-rate">Rate of Interest 7.25%</div>
            <h3>{t.product1Title}</h3>
            <p>{t.product1Desc}</p>
            <ul className="product-features">
              <li>{t.product1Feature1}</li>
              <li>{t.product1Feature2}</li>
              <li>{t.product1Feature3}</li>
            </ul>
            <button className="product-button">{t.product1Button}</button>
          </div>

          {/* Product 2 - Personal Loan */}
          <div className="product-card" onClick={() => navigate('/personal-loan')}>
            <div className="product-icon">💰</div>
            <div className="interest-rate">Rate of Interest 10.5%</div>
            <h3>{t.product2Title}</h3>
            <p>{t.product2Desc}</p>
            <ul className="product-features">
              <li>{t.product2Feature1}</li>
              <li>{t.product2Feature2}</li>
              <li>{t.product2Feature3}</li>
            </ul>
            <button className="product-button">{t.product2Button}</button>
          </div>

          {/* Product 3 - Loan Against Property */}
          <div className="product-card" onClick={() => navigate('/loan-against-property')}>
            <div className="product-icon">🏢</div>
            <div className="interest-rate">Rate of Interest 8.75%</div>
            <h3>{t.product3Title}</h3>
            <p>{t.product3Desc}</p>
            <ul className="product-features">
              <li>{t.product3Feature1}</li>
              <li>{t.product3Feature2}</li>
              <li>{t.product3Feature3}</li>
            </ul>
            <button className="product-button">{t.product3Button}</button>
          </div>

          {/* Product 4 - Business Loan */}
          <div className="product-card" onClick={() => navigate('/business-loan')}>
            <div className="product-icon">📈</div>
            <div className="interest-rate">Rate of Interest 11.2%</div>
            <h3>{t.product4Title}</h3>
            <p>{t.product4Desc}</p>
            <ul className="product-features">
              <li>{t.product4Feature1}</li>
              <li>{t.product4Feature2}</li>
              <li>{t.product4Feature3}</li>
            </ul>
            <button className="product-button">{t.product4Button}</button>
          </div>

          {/* Product 5 - Car Loan */}
          <div className="product-card" onClick={() => navigate('/car-loan')}>
            <div className="product-icon">🚗</div>
            <div className="interest-rate">Rate of Interest 8.9%</div>
            <h3>{t.product5Title}</h3>
            <p>{t.product5Desc}</p>
            <ul className="product-features">
              <li>{t.product5Feature1}</li>
              <li>{t.product5Feature2}</li>
              <li>{t.product5Feature3}</li>
            </ul>
            <button className="product-button">{t.product5Button}</button>
          </div>

          {/* Product 6 - Education Loan */}
          <div className="product-card" onClick={() => navigate('/education-loan')}>
            <div className="product-icon">🎓</div>
            <div className="interest-rate">Rate of Interest 8.3%</div>
            <h3>{t.product6Title}</h3>
            <p>{t.product6Desc}</p>
            <ul className="product-features">
              <li>{t.product6Feature1}</li>
              <li>{t.product6Feature2}</li>
              <li>{t.product6Feature3}</li>
            </ul>
            <button className="product-button">{t.product6Button}</button>
          </div>
        </div>
      </section>







      {/* Insurance Section */}
      <section id="insurance" className="section insurance-section">
        <div className="section-header">
          <h2>{t.insuranceTitle}</h2>
          <p>{t.insuranceSubtitle}</p>
        </div>
        <div className="insurance-grid">
          <div className="insurance-card">
            <div className="insurance-icon">❤️</div>
            <h3>{t.insurance1Title}</h3>
            <p>{t.insurance1Desc}</p>
            <p className="insurance-price">{t.insurance1Price}</p>
            <button className="product-button">{t.insurance1Button}</button>
          </div>
          <div className="insurance-card">
            <div className="insurance-icon">🩺</div>
            <h3>{t.insurance2Title}</h3>
            <p>{t.insurance2Desc}</p>
            <p className="insurance-price">{t.insurance2Price}</p>
            <button className="product-button">{t.insurance2Button}</button>
          </div>
          <div className="insurance-card">
            <div className="insurance-icon">🛡️</div>
            <h3>{t.insurance3Title}</h3>
            <p>{t.insurance3Desc}</p>
            <p className="insurance-price">{t.insurance3Price}</p>
            <button className="product-button">{t.insurance3Button}</button>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        {/* Main Timeline Component */}
        {/* <Timeline /> */}
        <StepsFlow />
      </section >

      {/* DSA Section */}
      <section section id="dsa" className="section dsa-section" >
        <div className="dsa-content">
          <h2>{t.dsaTitle}</h2>
          <p>{t.dsaSubtitle}</p>
          <p>{t.dsaDescription}</p>
          <div className="dsa-benefits">
            <div className="benefit-item">
              <h4>{t.benefit1Title}</h4>
              <p>{t.benefit1Desc}</p>
            </div>
            <div className="benefit-item">
              <h4>{t.benefit2Title}</h4>
              <p>{t.benefit2Desc}</p>
            </div>
            <div className="benefit-item">
              <h4>{t.benefit3Title}</h4>
              <p>{t.benefit3Desc}</p>
            </div>
          </div>
          <button className="product-button" onClick={() => setIsDSAFormOpen(true)}>{t.dsaButton}</button>
        </div>
      </section >









      {/* our team Section */}


      <section section id="our-team" className="our-team-section" >
        <h2 className="team-title">{translations[currentLanguage].teamTitle}</h2>
        <div className="team-members-wrapper">
          {translations[currentLanguage].teamMembers.map((member, index) => (
            <div key={index} className="team-member">
              <img src={member.photo} alt={member.name} className="team-photo" />
              <p className="team-name">{member.name}</p>
              <p className="team-position">{member.position}</p>
            </div>
          ))}
        </div>
      </section >







      {/* FAQ Section with Background Image */}
      <section section id="faq" className="section faq-section" >
        <div className="faq-background-overlay"></div>
        <div className="section-header">
          <h2>{t.faqTitle}</h2>
          <p>{t.faqSubtitle}</p>
        </div>
        <div className="faq-container">
          <div className="faq-item">
            <div className="faq-question" onClick={() => toggleFaq(1)}>
              {t.faq1Question}
              <span>{openFaqs[1] ? '−' : '+'}</span>
            </div>
            {openFaqs[1] && <div className="faq-answer">{t.faq1Answer}</div>}
          </div>
          <div className="faq-item">
            <div className="faq-question" onClick={() => toggleFaq(2)}>
              {t.faq2Question}
              <span>{openFaqs[2] ? '−' : '+'}</span>
            </div>
            {openFaqs[2] && <div className="faq-answer">{t.faq2Answer}</div>}
          </div>
          <div className="faq-item">
            <div className="faq-question" onClick={() => toggleFaq(3)}>
              {t.faq3Question}
              <span>{openFaqs[3] ? '−' : '+'}</span>
            </div>
            {openFaqs[3] && <div className="faq-answer">{t.faq3Answer}</div>}
          </div>
          <div className="faq-item">
            <div className="faq-question" onClick={() => toggleFaq(4)}>
              {t.faq4Question}
              <span>{openFaqs[4] ? '−' : '+'}</span>
            </div>
            {openFaqs[4] && <div className="faq-answer">{t.faq4Answer}</div>}
          </div>
        </div>
      </section >






      {/* Banking Partners Section */}
      <section section className="banks-partner-section" >
        <div className="section-header">
          <h2>Our 100+ Banking Partners</h2>
          <p>Trusted by India's Leading Financial Institutions</p>
        </div>

        <div className="banks-listing-container">
          {/* First Row */}
          <ul
            className="banks-row-1"
            onMouseEnter={() => {
              const row = document.querySelector('.banks-row-1');
              if (row) row.style.animationPlayState = 'paused';
            }}
            onMouseLeave={() => {
              const row = document.querySelector('.banks-row-1');
              if (row) row.style.animationPlayState = 'running';
            }}
          >
            <li><img src="/bank-logos/hdfc8.png" alt="HDFC Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/piramal3.png" alt="Piramal Finance" className="bank-logo" /></li>
            <li><img src="/bank-logos/Union.png" alt="Union Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/dcb.png" alt="DCB Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/incre.png" alt="Incred Finance" className="bank-logo" /></li>
            <li><img src="/bank-logos/sbi.png" alt="SBI" className="bank-logo" /></li>
            <li><img src="/bank-logos/icici.png" alt="ICICI Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/axis3.png" alt="Axis Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/yes.png" alt="Yes Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/bajaj.png" alt="Bajaj Finserv" className="bank-logo" /></li>
            <li><img src="/bank-logos/bob3.png" alt="Bank of Baroda" className="bank-logo" /></li>
            <li><img src="/bank-logos/kotak.png" alt="Kotak Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/idfc.png" alt="IDFC First Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/Indusind.png" alt="IndusInd Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/Federal.png" alt="Federal Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/bandhan.png" alt="Bandhan Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/canara.png" alt="Canara Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/punjab.png" alt="PNB" className="bank-logo" /></li>
          </ul>

          {/* Second Row */}
          <ul
            className="banks-row-2"
            onMouseEnter={() => {
              const row = document.querySelector('.banks-row-2');
              if (row) row.style.animationPlayState = 'paused';
            }}
            onMouseLeave={() => {
              const row = document.querySelector('.banks-row-2');
              if (row) row.style.animationPlayState = 'running';
            }}
          >
            <li><img src="/bank-logos/Central.png" alt="Central Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/boi.png" alt="Bank of India" className="bank-logo" /></li>
            <li><img src="/bank-logos/uco.png" alt="UCO Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/over.png" alt="IOB" className="bank-logo" /></li>
            <li><img src="/bank-logos/idbi.png" alt="IDBI Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/south.jpg" alt="South Indian Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/city.png" alt="City Union Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/karur.png" alt="Karur Vysya Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/Karnataka.png" alt="Karnataka Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/rbl.png" alt="RBL Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/au.png" alt="AU Small Finance Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/eq.png" alt="Equitas Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/esaf.png" alt="ESAF Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/sury.png" alt="Suryoday Bank" className="bank-logo" /></li>
          </ul>
        </div>
      </section >



      {/* New Infinite Scrolling Testimonials Section */}
      <section section id="testimonials" className="section testimonials-section" >
        <div className="section-header">
          <h2>{t.testimonialTitle}</h2>
          <p>{t.testimonialSubtitle}</p>
        </div>

        <div className="testimonials-marquee">
          <div className="testimonials-track">
            {/* Original set */}
            {t.testimonials.map((testimonial, index) => (
              <div key={`orig-${index}`} className="testimonial-card-marquee">
                <div className="testimonial-profile">
                  <img src={testimonial.photo} alt={testimonial.name} className="profile-photo" />
                  <div>
                    <h4>{testimonial.name}</h4>
                    <div className="star-rating">
                      {'★'.repeat(testimonial.rating) + '☆'.repeat(5 - testimonial.rating)}
                    </div>
                  </div>
                </div>
                <p>{testimonial.text}</p>
              </div>
            ))}

            {/* Duplicated set for seamless infinite loop */}
            {t.testimonials.map((testimonial, index) => (
              <div key={`dup-${index}`} className="testimonial-card-marquee">
                <div className="testimonial-profile">
                  <img src={testimonial.photo} alt={testimonial.name} className="profile-photo" />
                  <div>
                    <h4>{testimonial.name}</h4>
                    <div className="star-rating">
                      {'★'.repeat(testimonial.rating) + '☆'.repeat(5 - testimonial.rating)}
                    </div>
                  </div>
                </div>
                <p>{testimonial.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section >




      {/* Contact Us Section with Professional Background */}
      {/* Contact Us Section with Professional Background */}
      <section id="contact" className="section contact-section">
        <div className="contact-container">
          {/* Background Emojis/Decorations */}
          <div className="contact-bg-emoji">📧</div>
          <div className="contact-bg-emoji">📱</div>
          <div className="contact-bg-emoji">💬</div>
          <div className="contact-bg-emoji">👥</div>

          <div className="contact-left">
            <h2>Contact Us <span className="contact-emoji">📞</span></h2>
            <p className="contact-description">
              <strong><span className="email-emoji">📧</span> Email: krishnafinconcept09@gmail.com</strong><br />
              <span className="or-text"><span className="or-emoji">📝</span> or Fill the form</span>
            </p>
          </div>

          <div className="contact-right">
            <div className="contact-form-container">
              <h3>Get in Touch <span className="form-emoji">👋</span></h3>

              {/* Submission Status Message */}
              {submitMessage && (
                <div className={`submit-message ${submitStatus}`}>
                  {submitMessage}
                  <button
                    className="close-message-btn"
                    onClick={() => {
                      setSubmitMessage('');
                      setSubmitStatus('');
                      localStorage.removeItem('contactFormMessage');
                      localStorage.removeItem('contactFormStatus');
                    }}
                  >
                    ×
                  </button>
                </div>
              )}

              <form className="contact-form" onSubmit={handleContactSubmit}>
                {/* Full Name | PAN - Single Line */}
                <div className="form-row">
                  <div className="form-group">
                    <label><span className="field-emoji">👤</span> Full Name *</label>
                    <input
                      type="text"
                      name="fullname"
                      value={contactForm.fullname}
                      onChange={handleContactInputChange}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label><span className="field-emoji">📄</span> PAN Number</label>
                    <input
                      type="text"
                      name="pan_number"
                      value={contactForm.pan_number}
                      onChange={handleContactInputChange}
                      placeholder="ABCDE1234F"
                      maxLength="10"
                      style={{ textTransform: "uppercase" }}
                    />
                  </div>
                </div>

                {/* Email | Mobile - Single Line */}
                <div className="form-row">
                  <div className="form-group second-option-parent">
                    <label><span className="field-emoji">📧</span> E-mail *</label>
                    <div className='second-option'>
                      <div className='button' onClick={() => {
                        setIsSecondEmailOpen(!isSecondEmailOpen);
                        setContactForm(prev => ({
                          ...prev,
                          secondary_email: '',
                        }));
                      }}>
                        {!isSecondEmailOpen ? "+" : "-"}
                      </div>
                    </div>
                    <input
                      type="email"
                      name="email"
                      value={contactForm.email}
                      onChange={handleContactInputChange}
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                  <div className="form-group second-option-parent">
                    <label><span className="field-emoji">📱</span> Mobile *</label>
                    <div className='second-option'>
                      <div className='button' onClick={() => {
                        setIsSecondMobileOpen(!isSecondMobileOpen);
                        setContactForm(prev => ({
                          ...prev,
                          secondary_mobile: '',
                        }));
                      }}>
                        {!isSecondMobileOpen ? "+" : "-"}
                      </div>
                    </div>
                    <input
                      type="tel"
                      name="mobile"
                      value={contactForm.mobile}
                      onChange={handleContactInputChange}
                      placeholder="Enter your 10-digit mobile number"
                      required
                      pattern="[0-9]{10}"
                      title="Please enter exactly 10 digits"
                    />
                  </div>
                </div>

                {/* Alternate Email (if opened) */}
                {isSecondEmailOpen && (
                  <div className="form-row">
                    <div className="form-group">
                      <label><span className="field-emoji">📧</span> Alternate E-mail</label>
                      <input
                        type="email"
                        name="secondary_email"
                        value={contactForm.secondary_email}
                        onChange={handleContactInputChange}
                        placeholder="Enter alternate email"
                      />
                    </div>
                    <div className="form-group" style={{ visibility: 'hidden' }}>
                      {/* Empty div for spacing */}
                      <label>&nbsp;</label>
                      <input style={{ visibility: 'hidden' }} />
                    </div>
                  </div>
                )}

                {/* Alternate Mobile (if opened) */}
                {isSecondMobileOpen && (
                  <div className="form-row">
                    <div className="form-group">
                      <label><span className="field-emoji">📱</span> Alternate Mobile</label>
                      <input
                        type="tel"
                        name="secondary_mobile"
                        value={contactForm.secondary_mobile}
                        onChange={handleContactInputChange}
                        placeholder="Enter alternate mobile number"
                        pattern="[0-9]{10}"
                        title="Please enter exactly 10 digits"
                      />
                    </div>
                    <div className="form-group" style={{ visibility: 'hidden' }}>
                      {/* Empty div for spacing */}
                      <label>&nbsp;</label>
                      <input style={{ visibility: 'hidden' }} />
                    </div>
                  </div>
                )}

                {/* Main Product | Sub Product - Single Line */}
                <div className="form-row">
                  <div className="form-group">
                    <label><span className="field-emoji">📋</span> Our Services *</label>
                    <select
                      className="loan-type-select"
                      name="main_product"
                      value={contactForm.main_product}
                      onChange={handleContactInputChange}
                    >
                      <option value=""> -- Select -- </option>
                      <option value="loan">Loan</option>
                      <option value="insurance">Insurance</option>
                      <option value="real_estate">Real Estate</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label><span className="field-emoji">📊</span>Service Type *</label>
                    <select
                      className="loan-type-select"
                      name="sub_product"
                      value={contactForm.sub_product}
                      onChange={handleContactInputChange}
                      disabled={!contactForm.main_product}
                    >
                      <option value=""> -- Select -- </option>
                      {/* Loan options */}
                      {contactForm.main_product === 'loan' && (
                        <>
                          <option value="Home Loan">Home Loan</option>
                          <option value="Business Loan">Business Loan</option>
                          <option value="Personal Loan">Personal Loan</option>
                          <option value="Education Loan">Education Loan</option>
                          <option value="Car Loan">Car Loan</option>
                          <option value="Loan Against Property">Loan Against Property</option>
                        </>
                      )}
                      {/* Insurance options */}
                      {contactForm.main_product === 'insurance' && (
                        <>
                          <option value="Life Insurance">Life Insurance</option>
                          <option value="Health Insurance">Health Insurance</option>
                          <option value="General Insurance">General Insurance</option>
                          <option value="Car Insurance">Car Insurance</option>
                          <option value="Travel Insurance">Travel Insurance</option>
                          <option value="Home Insurance">Home Insurance</option>
                        </>
                      )}
                      {/* Real Estate options */}
                      {contactForm.main_product === 'real_estate' && (
                        <>
                          <option value="Residential Property">Residential Property</option>
                          <option value="Commercial Property">Commercial Property</option>
                          <option value="Plot/Land">Plot/Land</option>
                          <option value="Rental Property">Rental Property</option>
                          <option value="Property Investment">Property Investment</option>
                        </>
                      )}
                      {/* Other options */}
                      {contactForm.main_product === 'other' && (
                        <>
                          <option value="CRM">CRM</option>
                          <option value="Website">Website</option>
                        </>
                      )}
                    </select>
                  </div>
                </div>

                <div className="terms-row">
                  <input type="checkbox" onChange={(e) => checkTerms(e)} id="terms" name="terms" />
                  <label htmlFor="terms" className="terms-label">
                    <span className="terms-emoji"></span> I agree to receive promotional messages from WhatsApp/SMS. *
                  </label>
                </div>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting || !hasAgreedTerms}
                >
                  <span className="btn-emoji">📞</span>
                  {isSubmitting ? 'Submitting...' : 'Get a Call Back'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>


      {/* Footer */}
      {/* <footer>
        <div className="footer-content">
          <div className="footer-section">
            <h4>{t.footerAbout}</h4>
            <p>{t.footerDescription}</p>
            <div className="social-icons">
              <button className="social-icon">f</button>
              <button className="social-icon">t</button>
              <button className="social-icon">in</button>
              <button className="social-icon">ig</button>
            </div>
          </div>
          <div className="footer-section">
            <h4>{t.footerProducts}</h4>
            <ul className="footer-links">
              <li><button className="footer-link" onClick={() => navigate('/home-loan')}>{t.footerHome}</button></li>
              <li><button className="footer-link" onClick={() => navigate('/personal-loan')}>{t.footerPersonal}</button></li>
              <li><button className="footer-link" onClick={() => navigate('/business-loan')}>{t.footerBusiness}</button></li>
              <li><button className="footer-link" onClick={() => navigate('/loan-against-property')}>{t.footerLap}</button></li>
              <li><button className="footer-link" onClick={() => navigate('/car-loan')}>{t.footerCar}</button></li>
              <li><button className="footer-link" onClick={() => navigate('/education-loan')}>{t.footerEducation}</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t.footerServices}</h4>
            <ul className="footer-links">
              <li><button className="footer-link">{t.footerCredit}</button></li>
              <li><button className="footer-link">{t.footerInsurance}</button></li>
              <li><button className="footer-link">{t.footerGold}</button></li>
              <li><button className="footer-link">{t.footerBills}</button></li>
              <li><button className="footer-link">{t.footerCreditScore}</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><button className="footer-link" onClick={() => setIsDSAFormOpen(true)}>{t.footerPartner}</button></li>
              <li><button className="footer-link" onClick={() => {
                // Scroll to contact section
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}>{t.footerContact}</button></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          © {new Date().getFullYear()} Krishna Finconcept Services. All rights reserved.
        </div>
      </footer> */}




      {/* Congratulations Popup - Add this before the chatbot */}
      {/* <div className="congratulations-popup" style={{
        position: 'fixed',
        bottom: '5px',
        left: '5px',
        background: 'var(--primary)',
        color: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(76, 175, 80, 0.3)',
        zIndex: 9998,
        animation: 'slideInFromLeft 0.5s ease-out',
        display: 'none',
        maxWidth: '375px'
      }}>
        <div className="popup-content">
        </div>
        <button className="close-popup" style={{
          position: 'absolute',
          top: '5px',
          right: '10px',
          background: 'transparent',
          border: 'none',
          color: 'white',
          fontSize: '16px',
          cursor: 'pointer'
        }}>×</button>
      </div> */}






      {/* Krishna Loan Chatbot - Bottom Right Corner */}
      <div dangerouslySetInnerHTML={{
        __html: `
    <div class="chatbot-container" id="chatbotContainer">
        <div class="chat-window" id="chatWindow">
            <div class="chat-header">
                <div class="chat-header-info">
                    <div class="chat-avatar"><i class="fas fa-hand-holding-usd"></i></div>
                    <div class="chat-title">
                        <h3>Krishna Loan Assistant</h3>
                        <p><span class="status-dot"></span> Online - Ready to help</p>
                    </div>
                </div>
                <div class="chat-controls">
                    <button class="control-btn" id="minimizeBtn" title="Minimize"><i class="fas fa-minus"></i></button>
                    <button class="control-btn" id="closeBtn" title="Close"><i class="fas fa-times"></i></button>
                </div>
            </div>

            <div class="chat-body" id="chatBody">
                <div class="message bot-message" id="welcomeMessage">
                    <strong>👋 Welcome to Krishna Loan!</strong><br><br>
                    I'm your financial assistant. I can help you with:
                    <div class="quick-actions" id="quickActions">
                        <button class="action-btn" data-action="cibilscore">
                            <i class="fas fa-chart-line"></i> CIBIL Score
                        </button>
                        <button class="action-btn" data-action="emi">
                            <i class="fas fa-calculator"></i> EMI Calculator
                        </button>
                        <button class="action-btn" data-action="eligibility">
                            <i class="fas fa-check-circle"></i> Check Eligibility
                        </button>
                        <button class="action-btn" data-action="loans">
                            <i class="fas fa-university"></i> Loan Products
                        </button>
                        <button class="action-btn" data-action="apply">
                            <i class="fas fa-file-signature"></i> Apply Now
                        </button>
                        <button class="action-btn" data-action="documents">
                            <i class="fas fa-file-alt"></i> Required Documents
                        </button>
                        <button class="action-btn" data-action="contact">
                            <i class="fas fa-headset"></i> Contact Support
                        </button>
                    </div>
                </div>
            </div>

            <div class="chat-footer">
                <div class="input-container">
                    <input type="text" 
                           class="chat-input" 
                           id="chatInput" 
                           placeholder="Ask about CIBIL score, loans, EMI, interest rates..."
                           autocomplete="off">
                    <div class="input-actions">
                    </div>
                    <button class="send-btn" id="sendBtn">
                        <i class="fas fa-paper-plane"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Chat Toggle Button -->
        <button class="chatbot-toggle" id="chatbotToggle">
            <i class="fas fa-comments"></i>
            <div class="pulse-ring"></div>
        </button>
    </div>
` }} />


      {/* Professional DSA Registration Form Modal */}





      {/* Professional DSA Submission Popup */}
      {
        showDsaPopup && (
          <div className="dsa-popup-overlay">
            <div className={`dsa-popup ${dsaPopupType}`}>
              <div className="popup-header">
                <div className="popup-icon">
                  {dsaPopupType === 'success' ? '✅' :
                    dsaPopupType === 'error' ? '❌' :
                      dsaPopupType === 'info' ? '⏳' : 'ℹ️'}
                </div>
                <h3>
                  {dsaPopupType === 'success'
                    ? 'Form Submitted Successfully!'
                    : dsaPopupType === 'error'
                      ? 'Submission Failed'
                      : 'Processing...'}
                </h3>
                <button
                  className="popup-close-btn"
                  onClick={() => setShowDsaPopup(false)}
                >
                  ×
                </button>
              </div>
              <div className="popup-content">
                <p style={{
                  whiteSpace: 'pre-line',
                  textAlign: dsaPopupType === 'error' ? 'left' : 'center'
                }}>
                  {dsaPopupMessage}
                </p>
                {dsaPopupType === 'success' && (
                  <div className="popup-success-details">
                    <p><strong>Name:</strong> {dsaForm.fullname}</p>
                    <p><strong>Email:</strong> {dsaForm.email}</p>
                    <p><strong>Mobile:</strong> {dsaForm.mobile}</p>
                    <p className="popup-thankyou">Our team will contact you shortly for the next steps.</p>
                  </div>
                )}
                {dsaPopupType === 'error' && dsaPopupMessage.includes('Call to a member function store() on null') && (
                  <div className="popup-error-details">
                    <p><strong>Technical Issue:</strong> File upload failed on server.</p>
                    <p>Please try uploading documents again or contact support.</p>
                  </div>
                )}
              </div>
              <div className="popup-footer">
                <button
                  className="popup-action-btn"
                  onClick={() => setShowDsaPopup(false)}
                >
                  {dsaPopupType === 'success' ? 'Continue' :
                    dsaPopupType === 'error' ? 'Try Again' : 'OK'}
                </button>
              </div>
            </div>
          </div>
        )
      }

    </>
  );
};


export default Home;